var timeEntryCard = (function () {
    //-DATA------------------
    var payPeriodData;
    var locationData;
    var workCodeData;
    var requiredFields;
    var crossMidnightTimeData;
    var saveUserId; // userID used for cross midnight entries (eg, "charles")
    var personId; // Id of originator of entry (e.g., 37)
    var supervisorId;
    var rejectedTime;
    //-DOM------------------
    var card; // time entry card
    // dropdowns
    var payPeriodDropdown;
    var locationDropdown;
    var workCodeDropdown;
    var reasonDropdown;
    var locationTypeDropdown;
    // inputs
    var dateInput;
    var startTimeInput;
    var endTimeInput;
    var totalHoursInput;
    var noteInput;
    var rejectionReasonInput;
    // transportation
    var transportationBtn;
    var transportationPopup;
    var transportationDropdown;
    var licenseplateInput;
    var odometerStartInput;
    var odometerEndInput;
    var odometerTotalInput;
    var destinationInput;
    var originationInput;
    var reasonInput;
    var saveTransBtn;
    var deleteTransBtn;
    var cancelTransBtn;
    var transportationStartTimeInput;
    var transportationEndTimeInput;
    // btns
    var saveBtn;
    var deleteBtn;
    var cancelBtn;
    var saveOrUpdate;
    //-VALUES------------------
    var isEdit;
    var isAdminEdit;
    var isCardDisabled;
    var isCurrentRecordClosed;
    var status;
    var singleEntryId;
    var now;
    var nowHour;
    var nowMinutes;
    // consumers
    var consumerIds;
    var numberOfConsumersPresent;
    // dropdown & input
    var payPeriod;
    var entryDate;
    var workCode;
    var locationId;
    var startTime;
    var endTime;
    var totalHours;
    var noteText;
    var rejectionReason;
    //EVV
    var evvReasonCodeObj;
    var evvReasonCode;
    var locationTypeCode;
    var sendEvvData;
    var wcServiceType;
    var reasonRequired; // true || false
    var eligibleConsumersObj;
    var endTimeClicks;
    var evvAttest;
    var evvCommunity;
    var defaultTimesChanged; // true || false
    var defaultStartTimeChanged; // true || false (needed for 1st  entry in crossmidnight entries)
    var defaultEndTimeChanged; // true || false (needed for 2nd entry in crossmidnight entries)
    // time overlap
    var timeOverlap;
    // workcode related
    var isBillable; // Y || N
    var keyStartStop; // Y || N
    // coordinates
    var startLatitude;
    var startLongitude;
    var endLatitude;
    var endLongitude;
    // transportation
    var transportationSaved = false;
    var isTransportationValid;
    var destination = null;
    var origination = null;
    var odometerEnd = null;
    var odometerStart = null;
    var transportationEndTime = null;
    var transportationStartTime = null;
    var reason = null;
    var transportationType = null;
    var transportationReimbursable = null;
    var transportationUnits = null;
    var licensePlateNumber = null;
    // temp transportation data (holds data until save)
    var tmpTransportationType = null;
    var tmpTransportationReimbursable = null;
    var tmpOdometerStart = null;
    var tmpTransportationStartTime = null;
    var tmpTransportationEndTime = null;
    var tmpOdometerEnd = null;
    var tmpTransportationUnits = null;
    var tmpDestination = null;
    var tmpOrigination = null;
    var tmpReason = null;
    var tmpLicenseplate = null;
    var isEVVSingleEntry = false;
    var reasonCodeValue;
    var eVVChangeDate;
    var todayDate;
    var isEndTimeChangePermission;
    let evvDateCheck;

    // Action Nav
    //------------------------------------
    function handleActionNavEvent(target, isNew) {
        var targetAction = target.dataset.actionNav;

        switch (targetAction) {
            case 'miniRosterDone': {
                DOM.toggleNavLayout();
                const selectedConsumers = roster2.getActiveConsumers();
                moveConsumersToTimeCard(selectedConsumers);
                break;
            }
            case 'miniRosterCancel': {
                DOM.toggleNavLayout();
                break;
            }
        }
    }

    // Util
    //------------------------------------
    function errorPopup(message) {
        popup = POPUP.build({ classNames: 'error' });
        messageArea = document.createElement('p');
        messageArea.innerHTML = message;
        popup.appendChild(messageArea);
        POPUP.show(popup);
    }
    function disableInput(element) {
        if (!element) return;
        var input = element.querySelector('input');
        if (!input) input = element.querySelector('select');
        if (!input) input = element.querySelector('textarea');
        element.classList.add('disabled');
        input.setAttribute('readonly', 'true');
    }
    function enableInput(element) {
        if (!element) return;
        var input = element.querySelector('input');
        if (!input) input = element.querySelector('select');
        if (!input) input = element.querySelector('textarea');
        element.classList.remove('disabled');
        input.removeAttribute('readonly');
    }
    function getOverlapData() {
        return {
            token: $.session.Token,
            dateOfService: entryDate,
            startTime: startTime,
            endTime: endTime,
            singleEntryId: '',
            consumerId: consumerIds ? consumerIds.join(',') : '',
            locationId: locationId ? locationId : '',
            workCodeID: workCode ? workCode : '',
        };
    }
    function getSaveUpdateData(saveorupdate) {
        // setTotalHours();
        if (saveorupdate) saveOrUpdate = saveorupdate;
        var consumer_Ids = consumerIds ? consumerIds.join(',') : '';
        var data;
        if (!evvReasonCode || evvReasonCode === '%') evvReasonCode = '';
        if (keyStartStop === 'Y' && !startTime) startTime = startTimeInput.querySelector('input').value;
        let deviceOS = checkDeviceType();
        if (evvReasonCode !== '') deviceOS = 'Manual';

        if (saveOrUpdate === 'Save') {
            data = {
                // session variables
                token: $.session.Token,
                userId: crossMidnightTimeData && saveUserId ? saveUserId : $.session.UserId, // for crossmidnight -- this is used for PersonID (in DB)
                updaterId: crossMidnightTimeData && saveUserId ? $.session.UserId : '', // for crossmidnight -- this is used for UserID (in DB)
                personId: crossMidnightTimeData && saveUserId ? personId : 0, // for crossmidnight
                // card data
                checkHours: totalHours ? totalHours : '',
                crossMidnightCheckHours: crossMidnightTimeData
                    ? [
                        { day1TotalHours: crossMidnightTimeData.day1TotalHours },
                        { day2TotalHours: crossMidnightTimeData.day2TotalHours },
                    ]
                    : '',
                consumerId: consumer_Ids,
                dateOfService: entryDate,
                defaultStartTimeChanged: defaultStartTimeChanged ? defaultStartTimeChanged : false, // for crossmidnight evv entries
                defaultEndTimeChanged: defaultEndTimeChanged ? defaultEndTimeChanged : false, // for crossmidnight evv entries
                endTime: endTime ? endTime : '',
                endLatitude: endLatitude ? endLatitude : 0,
                endLongitude: endLongitude ? endLongitude : 0,
                inComments: noteText ? UTIL.removeUnsavableNoteText(noteText) : '',
                latitude: crossMidnightTimeData ? endLatitude : startLatitude,
                longitude: crossMidnightTimeData ? endLongitude : startLongitude,
                locationId: locationId ? locationId : '',
                numberOfConsumersPresent: numberOfConsumersPresent
                    ? numberOfConsumersPresent
                    : consumerIds
                        ? consumerIds.length
                        : 0,
                startTime: startTime ? startTime : '',
                workCodeID: workCode ? workCode : '',

                // transportation
                destination: destination ? UTIL.removeUnsavableNoteText(destination) : '',
                origination: origination ? UTIL.removeUnsavableNoteText(origination) : '',
                licensePlateNumber: licensePlateNumber ? UTIL.removeUnsavableNoteText(licensePlateNumber) : '',
                odometerEnd: !odometerEnd ? null : odometerEnd === 0 || odometerEnd === '0' ? null : odometerEnd,
                odometerStart: !odometerStart ? null : odometerStart === 0 || odometerStart === '0' ? null : odometerStart,
                transportationEndTime: transportationEndTime ? transportationEndTime : '',
                transportationStartTime: transportationStartTime ? transportationStartTime : '',
                reason: reason ? UTIL.removeUnsavableNoteText(reason) : '',
                transportationReimbursable: transportationReimbursable ? transportationReimbursable : '',
                transportationUnits: transportationUnits ? transportationUnits : '',
                // EVV
                deviceType: deviceOS,
                evvReason: evvReasonCode,
                attest: attestCheckbox.getElementsByTagName('input')[0].checked ? 'Y' : 'N',
                community: communityCheckbox.getElementsByTagName('input')[0].checked ? 'Y' : 'N',
                evvLocationType: locationTypeCode,
            };
        } else {
            data = {
                // session variables
                token: $.session.Token,
                userId: $.session.UserId,
                // card data
                singleEntryId,
                checkHours: totalHours ? totalHours : '',
                crossMidnightCheckHours: crossMidnightTimeData
                    ? [
                        { day1TotalHours: crossMidnightTimeData.day1TotalHours },
                        { day2TotalHours: crossMidnightTimeData.day2TotalHours },
                    ]
                    : '',
                consumerId: consumer_Ids,
                dateOfService: entryDate,
                defaultStartTimeChanged: defaultStartTimeChanged ? defaultStartTimeChanged : false, // for crossmidnight evv entries
                defaultEndTimeChanged: defaultEndTimeChanged ? defaultEndTimeChanged : false, // for crossmidnight evv entries
                endTime: endTime ? endTime : '',
                endLatitude: endLatitude ? endLatitude : 0,
                endLongitude: endLongitude ? endLongitude : 0,
                inComments: noteText ? UTIL.removeUnsavableNoteText(noteText) : '',
                locationId: locationId ? locationId : '',
                numberOfConsumersPresent: numberOfConsumersPresent
                    ? numberOfConsumersPresent
                    : consumerIds
                        ? consumerIds.length
                        : 0,
                startTime: startTime ? startTime : '',
                workCodeID: workCode ? workCode : '',
                // transportation
                destination: destination ? UTIL.removeUnsavableNoteText(destination) : '',
                origination: origination ? UTIL.removeUnsavableNoteText(origination) : '',
                licensePlateNumber: licensePlateNumber ? UTIL.removeUnsavableNoteText(licensePlateNumber) : '',
                odometerEnd: !odometerEnd ? null : odometerEnd === 0 || odometerEnd === '0' ? null : odometerEnd,
                odometerStart: !odometerStart ? null : odometerStart === 0 || odometerStart === '0' ? null : odometerStart,
                transportationEndTime: transportationEndTime ? transportationEndTime : '',
                transportationStartTime: transportationStartTime ? transportationStartTime : '',
                reason: reason ? UTIL.removeUnsavableNoteText(reason) : '',
                transportationReimbursable: transportationReimbursable ? transportationReimbursable : '',
                transportationUnits: transportationUnits ? transportationUnits : '',

                deviceType: deviceOS,
                evvReason: evvReasonCode,
                attest: attestCheckbox.getElementsByTagName('input')[0].checked ? 'Y' : 'N',
                community: communityCheckbox.getElementsByTagName('input')[0].checked ? 'Y' : 'N',
                updateEVVReason: $.session.singleEntrycrossMidnight && !defaultStartTimeChanged ? 'false' : 'true',
                evvLocationType: locationTypeCode,
            };
        }

        return data;
    }
    function checkDeviceType() {
        if ($.session.OS === 'iPhone/iPod' || $.session.OS === 'Linux') {
            return 'Mobile';
        } else return 'Other';
    }
    function setStartTimeLocation(pos) {
        startLatitude = pos.lat;
        startLongitude = pos.long;
    }
    function setEndTimeLocation(pos) {
        endLatitude = pos.lat;
        endLongitude = pos.long;
    }
    function setTotalHours() {
        if (keyStartStop === 'N') return;
        if (!startTime || !endTime) return;

        crossMidnightTimeData = {};

        var hoursInput = totalHoursInput.querySelector('input');
        var hours = UTIL.calculateTotalHours(startTime, endTime);

        if ((startTime === '00:00:00' || startTime === '00:00') && endTime === '00:00') {
            // user entered midnight for both start and end time
            totalHours = hours;
            hoursInput.value = totalHours;
            $.session.singleEntrycrossMidnight = false;
            crossMidnightTimeData = {};
        } else if (hours < 0 || hours === '0.00') {
            // user entered time period that spans into the next day
            // for the database entries
            var totalHours1 = UTIL.calculateTotalHours(startTime, '00:00');
            var totalHours2 = UTIL.calculateTotalHours('00:00', endTime);
            // for display on the screen
            totalHours = Number(totalHours1) + Number(totalHours2);
            // totalHours = (2400 + hours * 100)/100;
            hoursInput.value = totalHours.toFixed(2);
            $.session.singleEntrycrossMidnight = true;

            crossMidnightTimeData = {
                day1StartTime: startTime,
                day1EndTime: '00:00',
                day1TotalHours: totalHours1,
                day2StartTime: '00:00',
                day2EndTime: endTime,
                day2TotalHours: totalHours2,
            };
        } else {
            // user entered time period all within one day
            totalHours = hours;
            hoursInput.value = totalHours;
            $.session.singleEntrycrossMidnight = false;
            crossMidnightTimeData = {};
        }
    }

    function updateDateValMinMax(resetDate = true) {
        var todaysDate = UTIL.getTodaysDate();

        // if today is within the current pay period, then today is selected date; otherwise, payperiod start is selected date
        if (resetDate) {
            if (todaysDate <= payPeriod.end && todaysDate >= payPeriod.start) {
                entryDate = todaysDate;
            } else {
                entryDate = payPeriod.start;
            }
        }
        var input = dateInput.querySelector('input');
        if (resetDate) input.value = entryDate;
        input.setAttribute('min', payPeriod.start);
        input.setAttribute('max', payPeriod.end);

        // Set Min/Max Dates for Billable Work Codes
        if (isEdit) {
            if (isBillable === 'Y') {
                input.setAttribute('min', entryDate);
                input.setAttribute('max', entryDate);
            }
        } else {
            // NEW
            // If todays date is within the pay period, set the max to today's date. Otherwise max stays set to pay period end date.
            if (isBillable === 'Y' && todaysDate <= payPeriod.start) {
                // input.setAttribute('min', entryDate);
                input.setAttribute('max', UTIL.getTodaysDate());
            }
        }
        roster2.updateSelectedDate(entryDate);
    }
    async function setEditDataValues(editData) {
        var ed = editData[0];
        status = ed.Anywhere_Status;
        singleEntryId = ed.Single_Entry_ID;
        entryDate = UTIL.formatDateToIso(ed.Date_of_Service.split(' ')[0]);
        roster2.updateSelectedDate(entryDate);
        workCode = ed.Work_Code_ID;
        locationId = ed.Location_ID;
        startTime = ed.Start_Time;
        endTime = ed.End_Time === '23:59:59' ? '00:00' : ed.End_Time;
        totalHours = ed.Check_Hours;
        noteText = ed.Comments;
        locationTypeCode = ed.locationTypeCode;
        //get the rejection reason
        await singleEntryAjax.getSingleEntryById(singleEntryId, results => {
            entryData = results;
            rejectionReason = entryData[0].rejectionReason;
            if (document.getElementById('rejectionReason') != null)
                document.getElementById('rejectionReason').value = rejectionReason;
        });

        saveUserId = ed.User_ID; // userID used for cross midnight entries
        personId = ed.Person_ID;
        numberOfConsumersPresent = ed.Number_Consumers_Present;
        isBillable = ed.billable;
        keyStartStop = ed.keytimes;

        evvAttest = ed.attest;
        evvCommunity = ed.community;
        supervisorId = ed.supervisorId;
        rejectedTime = ed.rejected_time;
        destination = ed.destination;

        origination = ed.origination;
        odometerEnd = ed.odometerend;
        odometerStart = ed.odometerstart;
        transportationEndTime = ed.transportationendtime;
        transportationStartTime = ed.transportationstarttime;
        reason = ed.reason;
        transportationReimbursable = ed.Transportation_reimbursable;
        transportationUnits = ed.Transportation_Units;
        transportationType = ed.Transportation_reimbursable === 'N' ? 'Company' : 'Personal';
        licensePlateNumber = ed.licensePlateNumber;

        isTransportationValid = transportationType && transportationUnits ? true : false; 
    }
    function clearAllGlobalVariables() {
        //CLEAR EVV CACHE
        clearSavedSignaturesAndNotes();

        isEdit = undefined;
        isAdminEdit = undefined;
        isCardDisabled = undefined;
        status = undefined;
        singleEntryId = undefined;

        consumerIds = undefined;
        numberOfConsumersPresent = undefined;
        workCode = undefined;
        locationId = undefined;
        startTime = undefined;
        endTime = undefined;
        totalHours = undefined;
        noteText = undefined;
        rejectionReason = undefined;
        isBillable = undefined;
        keyStartStop = undefined;
        startLatitude = undefined;
        startLongitude = undefined;
        endLatitude = undefined;
        endLongitude = undefined;
        crossMidnightTimeData = undefined;
        $.session.singleEntrycrossMidnight = undefined;

        timeOverlap = undefined;

        isTransportationValid = undefined;
        destination = null;
        origination = null;
        odometerEnd = null;
        odometerStart = null;
        transportationEndTime = null;
        transportationStartTime = null;
        reason = null;
        licensePlateNumber = null;
        transportationType = null;
        transportationReimbursable = null;
        transportationUnits = null;

        tmpTransportationType = null;
        tmpTransportationReimbursable = null;
        tmpOdometerStart = null;
        tmpOdometerEnd = null;
        tmpTransportationStartTime = null;
        tmpTransportationEndTime = null;
        tmpTransportationUnits = null;
        tmpDestination = null;
        tmpOrigination = null;
        tmpReason = null;
        tmpLicenseplate = null;

        eligibleConsumersObj = {};
        reasonRequired = false;
        isEVVSingleEntry = false;
        defaultTimesChanged = false;
        defaultStartTimeChanged = false;
        defaultEndTimeChanged = false;
        evvAttest = null;
        evvCommunity = null;
        evvReasonCode = null;
        endTimeClicks = 0;
        locationTypeCode = null;
    }
    function clearCard() {
        // clear inputs & dropdowns
        var locDrop = locationDropdown.querySelector('select');
        var startInput = startTimeInput.querySelector('input');
        var endInput = endTimeInput.querySelector('input');
        var hoursInput = totalHoursInput.querySelector('input');
        if (!isEdit) locDrop.value = '';
        if (
            $.session.useSystemTimeClockInOut == 'N' ||
            ($.session.useSystemTimeClockInOut == 'Y' && isAdminEdit != true && !isEdit)
        ) {
            startInput.value = '';
            startTime = null;
            endInput.value = '';
            endTime = null;
            hoursInput.value = '';
        }
        endTimeClicks = 0;

        defaultTimesChanged = false;
        defaultStartTimeChanged = false;
        defaultEndTimeChanged = false;
        reasonRequired = false;

        evvAttest = null;
        evvCommunity = null;
        evvReasonCode = null;
        locationTypeCode = null;

        // Hide evv reason code
        if (evvDateCheck) {
            reasonInput.style.display = 'none';
        } else {
            reasonDropdown.style.display = 'none';
            reasonDropdown.classList.remove('error');

            const reasonCodeDropdown = reasonDropdown.querySelector('select');
            reasonCodeDropdown.value = '';
        }
        attestCheckbox.style.display = 'none';

        // clear selected consumers
        if (isEdit) {
        }

        //clearConsumerSection();
        checkPermissions();
    }

    function clearConsumerSection() {
        var consumerSection = document.querySelector('.timeCard__consumers');
        var consumers = [].slice.call(card.querySelectorAll('.seConsumerCard'));

        consumers.forEach(c => {
            var consumerCard = c.querySelector('.consumerCard');
            var consumerId = consumerCard.dataset.consumerId;
            consumerSection.removeChild(c);
            roster2.removeConsumerFromActiveConsumers(consumerId);
            consumerIds = consumerIds.filter(id => id !== consumerId);
            var activeConsumers = roster2.getActiveConsumers();
            numberOfConsumersPresent = activeConsumers ? activeConsumers.length : '0';
        });
    }

    // Consumers
    //------------------------------------
    async function getAllowedConsumersBasedOffResidence() {
        var residenceLocations = timeEntry.getResidenceLocations(); //Residence
        var rosterConsumers = await roster2.getAllRosterConsumers();
        var allowedConsumers = [];

        rosterConsumers.forEach(rc => {
            var primaryLocId = rc.conL;
            var locData = residenceLocations.filter(rl => rl.locationId === primaryLocId);
            if (locData.length > 0 && locData && locData[0].residence === 'Y') {
                // If a location is selected on the time entry card check this against
                // the primary location too. This usually only happens on edits.
                if (locationId) {
                    if (locationId === primaryLocId) {
                        allowedConsumers.push({ consumer_id: rc.id });
                    }
                } else {
                    allowedConsumers.push({ consumer_id: rc.id });
                }
            }
        });

        return allowedConsumers;
    }
    async function getAllowedConsumersBasedOffServiceLocations() {
        var residenceLocations = timeEntry.getResidenceLocations(); //Residence
        var rosterConsumers = await roster2.getAllRosterConsumers();
        var allowedConsumers = [];
        rosterConsumers.forEach(rc => {
            var serviceLocations = rc.LId.split('|');
            var locData = residenceLocations.filter(rl => {
                let exists = false;
                serviceLocations.forEach(sl => {
                    if (rl.locationId === sl && rl.residence === 'Y') exists = true;
                });
                return exists;
            });
            if (locData.length > 0 && locData) {
                allowedConsumers.push({ consumer_id: rc.id });
            }
        });

        return allowedConsumers;
    }
    async function setAllowedConsumers(callback) {
        switch (isBillable) {
            case 'Y':
                switch (isAdminEdit) {
                    case true:
                        if ($.session.SingleEntryEditTimeEntry) {
                            if (isEndTimeChangePermission)
                                // this is for if pay period is closed than disabled to delete counsumers
                                roster2.setAllowedConsumers([]);
                            else {
                                results = (await singleEntryAjax.getSingleEntryUsersByLocation(locationId, entryDate))
                                    .getSingleEntryUsersByLocationJSONResult;
                                roster2.setAllowedConsumers(results);
                            }
                            if (callback) callback();
                        } else {
                            roster2.setAllowedConsumers(['%']);
                            if (callback) callback();
                        }
                        break;
                    default:
                        if (isEndTimeChangePermission)
                            // this is for if pay period is closed than disabled to delete counsumers
                            roster2.setAllowedConsumers([]);
                        else {
                            results = (await singleEntryAjax.getSingleEntryUsersByLocation(locationId, entryDate))
                                .getSingleEntryUsersByLocationJSONResult;
                            roster2.setAllowedConsumers(results);
                        }
                        if (callback) callback();
                        break;
                }
                break;
            default:
                if (isEndTimeChangePermission)
                    // this is for if pay period is closed than disabled to delete counsumers
                    roster2.setAllowedConsumers([]);
                else {
                    roster2.setAllowedConsumers(['%']);
                }
                if (callback) callback();
                break;
        }
    }

    function showConsumerExtras(consumercard, consumerid) {
        var extras = POPUP.build({ id: 'consumerExtrasPopup' });
        extras.classList.add('extras');
        POPUP.show(extras);

        var evv;
        // check cache for instance by consumerid
        if (consumerid in $.session.evvDataCache) {
            // if exist in cache grab it
            evv = $.session.evvDataCache[consumerid];
            evv.editInit();
            evv.populatePopup();
        } else {
            // if nothing found create new EVV instance
            evv = new EVV({
                consumer: consumercard,
                consumerId: consumerid,
                signatureDataUrl: '',
                noteDataString: '',
                fromSave: false,
            });
            evv.populatePopup();
        }
    }
    function buildConsumerCard(consumerCard, consumerData) {
        consumerCard.classList.remove('highlighted');

        var card = document.createElement('div');
        card.classList.add('seConsumerCard');

        card.appendChild(consumerCard);

        if ($.session.singleEntryShowConsumerSignature === 'Y' || $.session.singleEntryShowConsumerNote === 'Y') {
            var hasNote = consumerData.hasNote === 'True' ? true : false;
            var hasSignature = consumerData.hasSignature === 'True' ? true : false;
            var classes = hasSignature || hasNote ? ['evv-highlight', 'extrasBtn'] : ['extrasBtn'];
            var extrasBtn = button.build({
                text: 'Action',
                type: 'contained',
                style: 'secondary',
                classNames: classes,
                callback: function () {
                    showConsumerExtras(consumerCard, consumerData.consumerid);
                },
            });
            card.appendChild(extrasBtn);
        }

        consumerCard.addEventListener('click', removeConsumerFromTimeCard);

        return card;
    }
    function moveConsumersToTimeCard(consumers) {
        var consumerList = document.querySelector('.timeCard__consumers');
        consumers.forEach(async consumer => {
            //If consumer is already on the selected consumer list ignore
            if (consumerIds.filter(id => id === consumer.id).length > 0) return;
            consumer.card.classList.remove('highlighted');
            var clone = consumer.card.cloneNode(true);
            var card = buildConsumerCard(clone, { consumerid: consumer.id });
            consumerList.appendChild(card);
            consumerIds.push(consumer.id);
            await evvCheckConsumerEligibility(consumer.id);
            numberOfConsumersPresent = consumerIds.length;
        });
        checkPermissions();
    }
    function removeConsumerFromTimeCard(event) {
        if ($.session.singleEntryAddConsumersOnBillable === 'P' && isEdit === true && consumerIds.length === 1) {
            // do not allow them to remove consumer and show an error
            var consumerWarningPopup = POPUP.build({
                classNames: ['warning'],
            });

            var warningMessage = document.createElement('p');
            warningMessage.innerHTML = 'You are not allowed to remove consumers from this entry.';

            consumerWarningPopup.appendChild(warningMessage);

            POPUP.show(consumerWarningPopup);
            return;
        }

        // remove consumer from active consumers
        var consumerSection = event.target.parentElement.parentElement;
        var consumerWrap = event.target.parentElement;
        consumerSection.removeChild(consumerWrap);

        var consumerid = event.target.dataset.consumerId;
        roster2.removeConsumerFromActiveConsumers(consumerid);
        consumerIds = consumerIds.filter(id => id !== consumerid);

        var activeConsumers = roster2.getActiveConsumers();
        numberOfConsumersPresent = activeConsumers ? activeConsumers.length : '0';
        // Remove consumer from evv data cache
        removeConsumerFromEVVCache(consumerid);
        //
        checkPermissions();
        evvCheckRemainingConsumers();
    }

    // Transportation
    //------------------------------------
    function saveTransportation() {
        transportationSaved = true;
        POPUP.hide(transportationPopup);
        transportationBtn.classList.add('success');
    }
    function deleteTransportation() {
        transportationSaved = false;
        POPUP.hide(transportationPopup);
        clearTransportationValues();
        transportationBtn.classList.remove('success');
    }
    function clearTransportationValues() {
        destination = null;
        origination = null;
        odometerEnd = null;
        odometerStart = null;
        transportationEndTime = null;
        transportationStartTime = null;
        reason = null;
        transportationType = null;
        transportationReimbursable = null;
        transportationUnits = null;
        licensePlateNumber = null;
    }
    function calculateMileage(startVal, endVal) {
        var start = parseInt(startVal);
        var end = parseInt(endVal);
        if (start && end && start <= end) {
            return end - start;
        } else {
            return 'error';
        }
    }
    function checkTransportationRequiredFields() {
        function checkOdometer() {
            var odoTotal = odometerTotalInput.querySelector('input');

            var odoStartVal = odometerStart;
            var odoEndVal = odometerEnd;
            var odoTotalVal = transportationUnits;

            var isStartValid;
            var isEndValid;

            function checkStartVal() {
                if (!odoStartVal || odoStartVal === '') {
                    odometerStartInput.classList.add('error');
                    return 'error';
                } else {
                    odometerStartInput.classList.remove('error');
                    return 'success';
                }
            }
            function checkEndVal() {
                if (!odoEndVal || odoEndVal === '') {
                    odometerEndInput.classList.add('error');
                    return 'error';
                } else {
                    odometerEndInput.classList.remove('error');
                    return 'success';
                }
            }
            function setToalMiles() {
                var totalMiles = calculateMileage(odoStartVal, odoEndVal);
                if (totalMiles !== 'error') {
                    odoTotal.value = totalMiles;
                    transportationUnits = totalMiles;
                    odometerTotalInput.classList.remove('error');
                } else {
                    odometerStartInput.classList.add('error');
                    odometerEndInput.classList.add('error');
                    odometerTotalInput.classList.add('error');
                }
            }

            if (requiredFields.isOdometerRequired === 'Y') {
                // only allowed to use odo start & stop inputs
                // odometerTotalInput.classList.add('disabled');
                isStartValid = checkStartVal();
                isEndValid = checkEndVal();
                if (isStartValid !== 'error' && isEndValid !== 'error') {
                    setToalMiles();
                }

                if (
                    transportationUnits !== '' &&
                    (odometerEnd == '' || odometerEnd == null) &&
                    (odometerStart == '' || odometerStart == null)
                ) {
                    odometerTotalInput.classList.remove('error');
                    odometerStartInput.classList.remove('error');
                    odometerEndInput.classList.remove('error');
                }

                if (
                    transportationUnits == null &&
                    (odometerEnd == '' || odometerEnd == null) &&
                    (odometerStart == '' || odometerStart == null)
                ) {
                    odometerTotalInput.classList.add('error');
                    odometerStartInput.classList.add('error');
                    odometerEndInput.classList.add('error');
                }

                return;
            }

            if (requiredFields.isOdometerRequired === 'N') {
                // allowed to use any of the three
                var startValue = !odoStartVal || odoStartVal === '' ? false : true;
                var endValue = !odoEndVal || odoEndVal === '' ? false : true;
                var totalValue = !odoTotalVal || odoTotalVal === '' ? false : true;

                if (!startValue && !endValue && !totalValue) {
                    // blank slate, clear all errors
                    // odometerTotalInput.classList.remove('disabled');
                    // odometerTotalInput.classList.remove('error');
                    odometerTotalInput.classList.add('error');
                    odometerStartInput.classList.remove('disabled');
                    odometerStartInput.classList.add('error');
                    odometerEndInput.classList.remove('disabled');
                    odometerEndInput.classList.add('error');

                    return;
                }

                if ((totalValue && (!startValue || !endValue)) || (odoStartVal === '0' && odoEndVal === '0')) {
                    // use total miles input
                    // var odometerTotalInput = odometerTotalInput.querySelector('input');
                    if (!startValue && endValue) {
                        //var odoStartInput = odometerStartInput.querySelector('input');
                        odometerEndInput.classList.remove('error');
                        odometerEndInput.classList.remove('disabled');
                        odometerStartInput.classList.add('error');
                        odometerStartInput.classList.remove('disabled');
                        odometerTotalInput.classList.add('disabled');
                        //  odometerTotalInput.classList.add('error');
                        odoTotal.value = '';
                        totalValue = false;
                        odoTotalVal = '';
                    }
                    if (!endValue && startValue) {
                        // var odoEndInput = odometerEndInput.querySelector('input');
                        odometerStartInput.classList.remove('error');
                        odometerStartInput.classList.remove('disabled');
                        odometerEndInput.classList.add('error');
                        odometerEndInput.classList.remove('disabled');
                        odometerTotalInput.classList.add('disabled');
                        // odometerTotalInput.classList.add('error');
                        odoTotal.value = '';
                        totalValue = false;
                        odoTotalVal = '';
                    }

                    if (!endValue && !startValue && odoTotal.value !== '') {
                        // var odoEndInput = odometerEndInput.querySelector('input');
                        odometerEndInput.classList.remove('error');
                        odometerEndInput.classList.add('disabled');
                        odometerStartInput.classList.remove('error');
                        odometerStartInput.classList.add('disabled');
                        odometerTotalInput.classList.remove('disabled');
                        odometerTotalInput.classList.remove('error');
                        // odoTotal.value = '';
                        //  totalValue = false;
                        //  odoTotalVal = '';
                    }

                    if (!endValue && !startValue && odoTotal.value === '') {
                        // var odoEndInput = odometerEndInput.querySelector('input');
                        odometerEndInput.classList.add('error');
                        odometerEndInput.classList.remove('disabled');
                        odometerStartInput.classList.add('error');
                        odometerStartInput.classList.remove('disabled');
                        odometerTotalInput.classList.remove('disabled');
                        odometerTotalInput.classList.add('error');
                        odoTotal.value = '';
                        totalValue = false;
                        odoTotalVal = '';
                    }
                    //odoStartInput.value = '';
                    // odoEndInput.value = '';

                    return;
                }

                if (startValue || endValue) {
                    // use odo start & end inputs
                    odometerTotalInput.classList.add('disabled');

                    isStartValid = checkStartVal();
                    isEndValid = checkEndVal();
                    if (isStartValid !== 'error' && isEndValid !== 'error') {
                        setToalMiles();
                    }

                    return;
                }
            }
        }

        function checkTotalMiles() {
            var totalMilesVal = transportationUnits;

            if (requiredFields.isOdometerRequired === 'N') {
                if (totalMilesVal === '' || !totalMilesVal) {
                    odometerTotalInput.classList.add('error');
                } else {
                    odometerTotalInput.classList.remove('error');
                }
            }
        }

        function checkReason() {
            var reasonVal = reason;

            if (requiredFields.isReasonRequired === 'Y') {
                if (reasonVal === '' || !reasonVal) {
                    reasonInput.classList.add('error');
                } else {
                    reasonInput.classList.remove('error');
                }
            }
        }

        function checkDestination() {
            var destinationVal = destination;

            if (requiredFields.isDestinationRequired === 'Y') {
                if (destinationVal === '' || !destinationVal) {
                    destinationInput.classList.add('error');
                } else {
                    destinationInput.classList.remove('error');
                }
            }
        }

        function checkOrigination() {
            var originationVal = origination;

            if (requiredFields.isDestinationRequired === 'Y') {
                if (originationVal === '' || !originationVal) {
                    originationInput.classList.add('error');
                } else {
                    originationInput.classList.remove('error');
                }
            }
        }

        function checkLicensePlate() {
            var licenseplateVal = licensePlateNumber;

            if (requiredFields.isLicensePlateRequired === 'Y') {
                if (licenseplateVal === '' || !licenseplateVal) {
                    licenseplateInput.classList.add('error');
                } else {
                    licenseplateInput.classList.remove('error');
                }
            }
        }

        // Require Time Entry Transportation Start and End Times
        function checkTransportationStartEndTimes() {
            var transportationEndTimeVal = transportationEndTime;
            var transportationStartTimeVal = transportationStartTime;

            if ($.session.requireTimeEntryTransportationTimes === 'Y') {
                if (transportationStartTimeVal === '' || !transportationStartTimeVal) {
                    transportationStartTimeInput.classList.add('error');
                } else {
                    transportationStartTimeInput.classList.remove('error');
                }

                if (transportationEndTimeVal === '' || !transportationEndTimeVal) {
                    transportationEndTimeInput.classList.add('error');
                } else {
                    if (UTIL.checkValidDateRange(transportationStartTimeVal, transportationEndTimeVal)) {
                        transportationEndTimeInput.classList.remove('error');
                    } else {
                        transportationEndTimeInput.classList.add('error');
                    }
                }
            } else {
                if (
                    transportationStartTimeVal &&
                    transportationEndTimeVal &&
                    transportationEndTimeVal !== '' &&
                    transportationStartTimeVal !== '' &&
                    !UTIL.checkValidDateRange(transportationStartTimeVal, transportationEndTimeVal)
                ) {
                    transportationEndTimeInput.classList.add('error');
                } else {
                    transportationEndTimeInput.classList.remove('error');
                }
            }
        }

        checkTotalMiles();
        checkOdometer();
        checkReason();
        checkDestination();
        checkOrigination();
        checkLicensePlate();
        checkTransportationStartEndTimes();

        var errors = [].slice.call(transportationPopup.querySelectorAll('.error'));

        if (errors.length > 0) {
            saveTransBtn.classList.add('disabled');
        } else {
            saveTransBtn.classList.remove('disabled');
        }

        return errors.length > 0 ? true : false;
    }
    function setupTransportationEvents() {
        // cache old values in case of cancel click
        var oldTransportationType;
        var oldlicenseplate;
        var oldTransportationReimbursable;
        var oldOdometerStart;
        var oldOdometerEnd;
        var oldTransportationEndTime;
        var oldTransportationStartTime;
        var oldTransportationUnits;
        var oldOrigination;
        var oldDestination;
        var oldReason;

        transportationDropdown.addEventListener('change', event => {
            var selectedOption = event.target.options[event.target.selectedIndex];

            oldTransportationType = transportationType;
            oldTransportationReimbursable = transportationReimbursable;

            if (selectedOption.value === 'Company') {
                transportationType = selectedOption.value;
                transportationReimbursable = 'N';
            } else if (selectedOption.value === 'Personal') {
                transportationType = selectedOption.value;
                transportationReimbursable = 'Y';
            }
            checkTransportationRequiredFields();
        });
        licenseplateInput.addEventListener('change', event => {
            if (!oldlicenseplate) oldlicenseplate = licensePlateNumber;
            licensePlateNumber = event.target.value;
            checkTransportationRequiredFields();
        });
        odometerStartInput.addEventListener('change', event => {
            if (!oldOdometerStart) oldOdometerStart = odometerStart;
            odometerStart = event.target.value;
            checkTransportationRequiredFields();
        });
        odometerEndInput.addEventListener('change', event => {
            if (!oldOdometerEnd) oldOdometerEnd = odometerEnd;
            odometerEnd = event.target.value;
            checkTransportationRequiredFields();
        });
        odometerTotalInput.addEventListener('change', event => {
            // oldTransportationUnits = transportationUnits;
            transportationUnits = event.target.value;
            checkTransportationRequiredFields();
        });
        transportationStartTimeInput.addEventListener('change', event => {
            if (!oldTransportationStartTime) oldTransportationStartTime = transportationStartTime;
            transportationStartTime = event.target.value;
            checkTransportationRequiredFields();
        });
        transportationEndTimeInput.addEventListener('change', event => {
            if (!oldTransportationEndTime) oldTransportationEndTime = transportationEndTime;
            transportationEndTime = event.target.value;
            checkTransportationRequiredFields();
        });
        originationInput.addEventListener('change', event => {
            if (!oldOrigination) oldOrigination = origination;
            origination = event.target.value;
            checkTransportationRequiredFields();
        });
        destinationInput.addEventListener('change', event => {
            if (!oldDestination) oldDestination = destination;
            destination = event.target.value;
            checkTransportationRequiredFields();
        });
        reasonInput.addEventListener('input', event => {
            if (!oldReason) oldReason = reason;
            reason = event.target.value;
            checkTransportationRequiredFields();
            //if (!hasErrors) saveTransBtn.classList.remove('disabled');
        });

        saveTransBtn.addEventListener('click', () => {
            saveTransportation();

            // since note field is always enabled we need to check it before eanbling save button
            if (isCardDisabled || isCurrentRecordClosed) {
                if (requiredFields.isNoteRequired === 'Y') {
                    if (noteText === '' || !noteText) {
                        noteInput.classList.add('error');
                        saveBtn.classList.add('disabled');
                    } else {
                        noteInput.classList.remove('error');
                        saveBtn.classList.remove('disabled');
                    }
                } else {
                    saveBtn.classList.remove('disabled');
                }
            } else {
                checkPermissions();
            }
        });
        saveTransBtn.addEventListener('keydown', e => {
            if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.altKey) {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        deleteTransBtn.addEventListener('click', deleteTransportation);
        deleteTransBtn.addEventListener('keydown', e => {
            if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.altKey) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
        cancelTransBtn.addEventListener('click', () => {
            if (transportationSaved) {
                transportationType = oldTransportationType ? oldTransportationType : transportationType;
                transportationReimbursable = oldTransportationReimbursable
                    ? oldTransportationReimbursable
                    : transportationReimbursable;
                odometerStart = oldOdometerStart || oldOdometerStart === '' ? oldOdometerStart : odometerStart;
                odometerEnd = oldOdometerEnd || oldOdometerEnd === '' ? oldOdometerEnd : odometerEnd;
                transportationEndTime =
                    oldTransportationEndTime || oldTransportationEndTime === ''
                        ? oldTransportationEndTime
                        : transportationEndTime;
                transportationStartTime =
                    oldTransportationStartTime || oldTransportationStartTime === ''
                        ? oldTransportationStartTime
                        : transportationStartTime;
                origination = oldOrigination || oldOrigination === '' ? oldOrigination : origination;
                destination = oldDestination || oldDestination === '' ? oldDestination : destination;
                reason = oldReason || oldReason === '' ? oldReason : reason;
                licensePlateNumber = oldlicenseplate || oldlicenseplate === '' ? oldlicenseplate : licensePlateNumber;
            } else {
                clearTransportationValues();
            }

            POPUP.hide(transportationPopup);
        });
    }
    function populateTransportationDropdown() {
        var data = [
            { value: 'Personal', text: 'Personal' },
            { value: 'Company', text: 'Company' },
        ];

        if (!transportationType || transportationType === 'Personal') {
            transportationType = 'Personal';
            transportationReimbursable = 'Y';
        }

        dropdown.populate(transportationDropdown, data, transportationType);
    }
    function buildTransportationPopup() {
        // clear tmp values
        tmpTransportationType = null;
        tmpTransportationReimbursable = null;
        tmpOdometerStart = null;
        tmpOdometerEnd = null;
        tmpTransportationUnits = null;
        tmpOrigination = null;
        tmpDestination = null;
        tmpReason = null;
        tmpLicenseplate = null;
        tmpTransportationStartTime = null;
        tmpTransportationEndTime = null;

        var popupClassNames = isCardDisabled
            ? ['timeEntryTransportationPopup', 'popup--filter', 'disabled']
            : ['timeEntryTransportationPopup', 'popup--filter'];

        transportationPopup = POPUP.build({
            classNames: ['timeEntryTransportationPopup', 'popup--filter'],
            hideX: true,
        });

        transportationDropdown = dropdown.build({
            label: 'Transportation Type',
            style: 'secondary',
        });
        licenseplateInput = input.build({
            label: 'License Plate',
            type: 'text',
            style: 'secondary',
            value: licensePlateNumber,
            attributes: [{ key: 'maxlength', value: 10 }],
        });
        transportationStartTimeInput = input.build({
            id: 'transportationStartTimeInput',
            type: 'time',
            label: 'Start Time',
            style: 'secondary',
            value: transportationStartTime,
        });
        transportationEndTimeInput = input.build({
            id: 'transportationEndTimeInput',
            type: 'time',
            label: 'End Time',
            style: 'secondary',
            value: transportationEndTime,
        });
        odometerStartInput = input.build({
            label: 'Odometer Start',
            type: 'number',
            style: 'secondary',
            value: odometerStart === '0' ? '' : odometerStart,
        });
        odometerEndInput = input.build({
            label: 'Odometer End',
            type: 'number',
            style: 'secondary',
            value: odometerEnd === '0' ? '' : odometerEnd,
        });
        odometerTotalInput = input.build({
            label: 'Total Miles',
            type: 'number',
            style: 'secondary',
            value: transportationUnits,
        });
        originationInput = input.build({
            label: 'Origination',
            type: 'textarea',
            style: 'secondary',
            value: origination,
        });
        destinationInput = input.build({
            label: 'Destination',
            type: 'textarea',
            style: 'secondary',
            value: destination,
        });
        reasonInput = input.build({
            label: 'Reason',
            type: 'textarea',
            style: 'secondary',
            value: reason,
        });

        saveTransBtn = button.build({
            text: 'Save',
            type: 'contained',
            style: 'secondary',
            classNames: 'disabled',
        });
        deleteTransBtn = button.build({
            text: 'Delete',
            type: 'outlined',
            style: 'secondary',
        });
        cancelTransBtn = button.build({
            text: 'Cancel',
            type: 'outlined',
            style: 'secondary',
            classNames: 'cancelTransBtn',
        });

        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        btnWrap.appendChild(saveTransBtn);
        btnWrap.appendChild(deleteTransBtn);
        btnWrap.appendChild(cancelTransBtn);

        transportationPopup.appendChild(transportationDropdown);

        timeWrap = document.createElement('div');
        timeWrap.classList.add('btnWrap');
        transportationStartTimeInput.style.width = '49%';
        transportationEndTimeInput.style.width = '49%';
        timeWrap.appendChild(transportationStartTimeInput);
        timeWrap.appendChild(transportationEndTimeInput);
        transportationPopup.appendChild(timeWrap);

        var inputWrap = document.createElement('div');
        inputWrap.classList.add('btnWrap');
        odometerStartInput.style.width = '49%';
        odometerEndInput.style.width = '49%';
        inputWrap.appendChild(odometerStartInput);
        inputWrap.appendChild(odometerEndInput);
        transportationPopup.appendChild(inputWrap);

        transportationPopup.appendChild(odometerTotalInput);
        transportationPopup.appendChild(licenseplateInput);
        transportationPopup.appendChild(originationInput);
        transportationPopup.appendChild(destinationInput);
        transportationPopup.appendChild(reasonInput);
        transportationPopup.appendChild(btnWrap);

        populateTransportationDropdown();
        setupTransportationEvents();
        checkTransportationRequiredFields();

        if (['I', 'D', 'S'].includes(status) || (status === 'A' && supervisorId !== $.session.PeopleId && !isAdminEdit)) {
            if (transportationDropdown) disableInput(transportationDropdown);
            if (licenseplateInput) disableInput(licenseplateInput);
            if (transportationStartTimeInput) disableInput(transportationStartTimeInput);
            if (transportationEndTimeInput) disableInput(transportationEndTimeInput);
            if (odometerStartInput) disableInput(odometerStartInput);
            if (odometerEndInput) disableInput(odometerEndInput);
            if (odometerTotalInput) disableInput(odometerTotalInput);
            if (originationInput) disableInput(originationInput);
            if (destinationInput) disableInput(destinationInput);

            if (reasonInput) enableInput(reasonInput);

            if (deleteTransBtn) {
                deleteTransBtn.classList.add('disabled');
                //deleteTransBtn.style.pointerEvents = 'none';
            }
        }

        POPUP.show(transportationPopup);
    }
    function buildTransportationBtn() {
        var classes = isTransportationValid ? ['transportationBtn', 'success'] : ['transportationBtn'];
        return (btn = button.build({
            text: 'Add Transportation',
            icon: 'car',
            style: 'secondary',
            type: 'outlined',
            classNames: classes,
        }));
    }

    // Permissions & Required Fields
    //------------------------------------
    function checkRequiredFields() {
        // date
        function checkDates() {
            var payPeriodStart = new Date(payPeriod.start.split('-').join('/'));
            var payPeriodEnd = new Date(payPeriod.end.split('-').join('/'));
            var newEntryDate = entryDate.split('-');
            newEntryDate[1] = newEntryDate[1] - 1;
            newEntryDate = new Date(newEntryDate[0], newEntryDate[1], newEntryDate[2], 0, 0, 0);

            // check if entered date is outside the pay period
            var isDateAfter = dates.isAfter(newEntryDate, payPeriodStart);
            var isDateBefore = dates.isBefore(newEntryDate, payPeriodEnd);

            if (!isDateAfter) isDateAfter = dates.isEqual(newEntryDate, payPeriodStart);
            if (!isDateBefore) isDateBefore = dates.isEqual(newEntryDate, payPeriodEnd);

            if (!isDateAfter || !isDateBefore) {
                dateInput.classList.add('error');
            } else {
                dateInput.classList.remove('error');
            }

            // check if entered date is beyond todays date
            var todayDate = new Date(UTIL.getTodaysDate().split('-').join('/'));
            var isDateAfterToday = dates.isAfter(newEntryDate, todayDate);

            // for non-billable work codes, selected date can be beyond today
            // Added isDateAfter, and isDateBefore check. Can't blanket remove the error for non-billable
            // because the date still has to be within the pay period
            if (isBillable === 'N' && isDateAfter && isDateBefore) dateInput.classList.remove('error');
            if (isBillable === 'Y' && isDateAfter && isDateBefore && isDateAfterToday) dateInput.classList.add('error');
        }
        // workcode
        function checkWorkcodes() {
            var workCodeSelect = workCodeDropdown.querySelector('select');
            var currentValue = workCodeSelect.value;
            if (currentValue === '%') {
                workCodeDropdown.classList.add('error');
            } else {
                workCodeDropdown.classList.remove('error');
            }
        }
        // location
        function checkLocation() {
            var isDisabled = locationDropdown.classList.contains('disabled');
            var locationSelect = locationDropdown.querySelector('select');
            var currentValue = locationSelect.value;
            if (isDisabled) {
                locationDropdown.classList.remove('error');
            } else {
                if (currentValue === '%' || currentValue === '') {
                    locationDropdown.classList.add('error');
                    roster2.toggleMiniRosterBtnVisible(false);
                } else {
                    locationDropdown.classList.remove('error');
                    if (isBillable === 'Y') roster2.toggleMiniRosterBtnVisible(true);
                }
            }
        }

        // startTime, endTime & totalHours
        function checkTimeAndHours() {
            var startInput = startTimeInput.querySelector('input');
            var endInput = endTimeInput.querySelector('input');
            var hoursInput = totalHoursInput.querySelector('input');

            if (!isBillable) {
                startTimeInput.classList.remove('error');
                totalHoursInput.classList.remove('error');
            } else {
                if (keyStartStop === 'Y') {
                    if (!timeOverlap) {
                        endTimeInput.classList.remove('error');
                    }

                    var isStartTimeValid = UTIL.validateTime(startInput.value);
                    var isEndTimeValid = UTIL.validateTime(endInput.value);
                    if (isStartTimeValid) {
                        startTimeInput.classList.remove('error');
                    } else {
                        startTimeInput.classList.add('error');
                    }

                    var todaysDate = UTIL.getTodaysDate();
                    // error endTime: for billable codes with Service Date today, don't allow cross over midnight (next day)
                    if (isEdit && evvReasonCode !== '') {
                        if (isBillable === 'Y' && entryDate === todaysDate && checkTimeForAfterNow(endInput.value)) {
                            endTimeInput.classList.add('error');
                        }
                    } else if (isEdit && evvReasonCode === '') {
                        if (isBillable === 'Y' && entryDate > todaysDate) {
                            endTimeInput.classList.add('error');
                        }
                    } else {
                        if (isBillable === 'Y' && entryDate === todaysDate && $.session.singleEntrycrossMidnight) {
                            endTimeInput.classList.add('error');
                        }
                    }
                    totalHoursInput.classList.remove('error');
                } else {
                    if (hoursInput.value === '' || hoursInput.value < 0) {
                        totalHoursInput.classList.add('error');
                    } else {
                        totalHoursInput.classList.remove('error');
                    }
                    startTimeInput.classList.remove('error');
                }
            }
        }
        function checkStartTimeInputsForAfterNow() {
            const tempNow = new Date();
            const convertedToday = new Date(tempNow.getFullYear(), tempNow.getMonth(), tempNow.getDate());
            const splitServiceDate = entryDate.split('-');
            const entryDateObj = new Date(splitServiceDate[0], parseInt(splitServiceDate[1]) - 1, splitServiceDate[2]);

            if (isBillable === 'Y' && sendEvvData === 'Y' && !(entryDateObj < convertedToday)) {
                if (checkTimeForAfterNow(startTime)) {
                    startTimeInput.classList.add('error');
                }
                if (checkTimeForAfterNow(endTime) && endTime !== '00:00') {
                    endTimeInput.classList.add('error');
                }
            }
        }
        // consumers
        function checkConsumers() {
            var activeConsumers = roster2.getActiveConsumers();
            var consumerError = document.querySelector('.consumerSectionError');

            if ($.session.useSystemTimeClockInOut == 'Y' && isAdminEdit != true) {
                disableInput(dateInput);
                disableInput(payPeriodDropdown);
            }

            if (isBillable === 'Y') {
                // error
                if ($.session.singleEntryAddConsumersOnBillable === 'P') {
                    // require a consumer to be picked
                    if (activeConsumers.length < 1) {
                        // show consumer error
                        consumerError.innerHTML = `*You must select at least one consumer.`;
                        consumerError.classList.add('error');
                        consumerError.classList.remove('hidden');
                        disableInput(startTimeInput);
                        disableInput(endTimeInput);
                    } else {
                        consumerError.classList.add('hidden');
                        consumerError.classList.remove('warning');
                        consumerError.classList.remove('error');
                        enableInput(startTimeInput);
                        enableInput(endTimeInput);

                        if ($.session.useSystemTimeClockInOut == 'Y' && isAdminEdit != true) {
                            disableInput(startTimeInput);
                            disableInput(endTimeInput);
                            var endInput = endTimeInput.querySelector('input');
                            if (isEdit && (endInput.value == null || endInput.value == '')) {
                                disableInput(startTimeInput);
                                enableInput(endTimeInput);
                            }
                        }
                    }
                }
                // warning
                if ($.session.singleEntryAddConsumersOnBillable === 'Y') {
                    // do not require a consumer to be picked but give warning
                    if (activeConsumers.length < 1) {
                        // show consumer warning
                        consumerError.innerHTML = `*It is advised you select a consumer.`;
                        consumerError.classList.add('warning');
                        consumerError.classList.remove('hidden');
                    } else {
                        consumerError.classList.add('hidden');
                        consumerError.classList.remove('warning');
                        consumerError.classList.remove('error');
                    }
                }
            } else {
                consumerError.classList.add('hidden');
                consumerError.classList.remove('warning');
                consumerError.classList.remove('error');
            }
        }
        // note
        function checkNote() {
            if (requiredFields.isNoteRequired === 'Y') {
                if (noteText === '' || !noteText) {
                    noteInput.classList.add('error');
                } else {
                    noteInput.classList.remove('error');
                }
            }
        }
        function checkEvv() {
            var isDisabled = reasonDropdown.classList.contains('disabled');
            var reasonSelect = reasonDropdown.querySelector('select');
            var currentValue = reasonSelect.value;
            if (isDisabled) {
                reasonDropdown.classList.remove('error');
            } else {
                if (
                    currentValue === '%' ||
                    (currentValue === '' && reasonRequired && (!evvReasonCode || evvReasonCode === '%') && defaultTimesChanged)
                ) {
                    if (reasonDropdown.style.display !== 'none') {
                        reasonDropdown.classList.add('error');
                    }
                } else {
                    reasonDropdown.classList.remove('error');
                }
            }
        }

        checkDates();
        checkWorkcodes();
        checkLocation();
        checkTimeAndHours();
        checkStartTimeInputsForAfterNow();
        checkConsumers();
        checkNote();
        checkEvv();

        var hasErrors = [].slice.call(document.querySelectorAll('.error'));

        if (status === 'A' || status === 'S' || status === 'I' || hasErrors.length !== 0) {
            if ($.session.SingleEntryEditTimeEntry && status === 'A') {
                if ($.session.disableSESaveGEOLocation === false) {
                    saveBtn.classList.remove('disabled');
                    saveAndSumbitBtn.classList.remove('disabled');
                }
                deleteBtn.classList.remove('disabled');

                if (hasErrors.length !== 0) {
                    saveBtn.classList.add('disabled');
                    saveAndSumbitBtn.classList.add('disabled');
                    deleteBtn.classList.add('disabled');
                }
            } else {
                saveBtn.classList.add('disabled');
                saveAndSumbitBtn.classList.add('disabled');
            }
        } else {
            if ($.session.disableSESaveGEOLocation === false) {
                saveBtn.classList.remove('disabled');
            }

            deleteBtn.classList.remove('disabled');

            if (keyStartStop === 'Y') {
                // if 'Y' then end time is enabled and we need to check for it
                if (endTime) {
                    if ($.session.disableSESaveGEOLocation === false) {
                        saveAndSumbitBtn.classList.remove('disabled');
                    }
                } else {
                    saveAndSumbitBtn.classList.add('disabled');
                }
            } else {
                // no check needed, done by hasErrors
                if ($.session.disableSESaveGEOLocation === false) {
                    saveAndSumbitBtn.classList.remove('disabled');
                }
            }
        }
    }

    function disableSection(section) {
        section.classList.add('disabled');
        section.style.pointerEvents = 'none';
        section.style.opacity = '0.5';
    }
    function showPayPeriodClosedMessage() {
        hidePayPeriodClosedMessage();
        var closureMessageDiv = document.createElement('div');
        closureMessageDiv.id = 'payPeriodClosureMessage';
        closureMessageDiv.className = 'error';
        closureMessageDiv.style.marginTop = '15px';
        closureMessageDiv.innerHTML =
            '<p style="margin: 0; font-weight: bold;">This pay period is closed. No changes can be made</p>';
        var timeCard = document.querySelector('.timeCard');
        if (timeCard && timeCard.parentNode) {
            timeCard.parentNode.insertBefore(closureMessageDiv, timeCard.nextSibling);
        }
    }
    function hidePayPeriodClosedMessage() {
        var existingMessage = document.getElementById('payPeriodClosureMessage');
        if (existingMessage) {
            existingMessage.remove();
        }
    }
    function checkPermissions() {
        isCurrentRecordClosed = false;
        if (typeof payPeriod !== 'undefined' && payPeriod && payPeriodData && Array.isArray(payPeriodData)) {
            const matchingRecord = payPeriodData.find(
                record => record.start === payPeriod.start && record.end === payPeriod.end,
            );
            if (matchingRecord) {
                isCurrentRecordClosed = matchingRecord.anywhereClosed === 'True' || matchingRecord.anywhereClosed === true;
            }
        }
        if (isCurrentRecordClosed) {
            if (dateInput) disableInput(dateInput);
            if (startTimeInput) disableInput(startTimeInput);
            if (endTimeInput) disableInput(endTimeInput);
            if (totalHoursInput) disableInput(totalHoursInput);
            if (locationDropdown) disableInput(locationDropdown);
            if (workCodeDropdown) disableInput(workCodeDropdown);
            if (licenseplateInput) disableInput(licenseplateInput);
            if (reasonDropdown) disableInput(reasonDropdown);
            if (locationTypeDropdown) disableInput(locationTypeDropdown);
            if (saveBtn) {
                saveBtn.classList.add('disabled');
                //saveBtn.style.pointerEvents = 'none';
            }
            if (deleteBtn) {
                deleteBtn.classList.add('disabled');
                //deleteBtn.style.pointerEvents = 'none';
            }
            if (saveAndSumbitBtn) {
                saveAndSumbitBtn.classList.add('disabled');
                //saveAndSumbitBtn.style.pointerEvents = 'none';
            }
            const consumerSection = document.querySelector('.timeCard__consumers');
            if (consumerSection) {
                disableSection(consumerSection);
            }
            roster2.toggleMiniRosterBtnVisible(false);
            showPayPeriodClosedMessage();
            return;
        }

        // Enable/Disable Fields
        if ($.session.SingleEntryEditTimeEntry && status === 'A') {
        } else if (
            $.session.editSingleEntryCardStatus === 'S' ||
            $.session.editSingleEntryCardStatus === 'I' ||
            $.session.editSingleEntryCardStatus === 'A'
        ) {
            disableInput(dateInput);
            disableInput(startTimeInput);
            disableInput(endTimeInput);
            enableInput(noteInput);
            if (licenseplateInput) disableInput(licenseplateInput);
        }

        // Location dropdown
        if (
            (isBillable === 'Y' || !isBillable) &&
            !$.session.singleEntryUseServiceLocations &&
            $.session.singleEntryAddConsumersOnBillable === 'P'
        ) {
            disableInput(locationDropdown);
        } else {
            enableInput(locationDropdown);
        }

        // Key Times
        if (!isBillable) {
            disableInput(totalHoursInput);
            disableInput(startTimeInput);
            disableInput(endTimeInput);
        } else {
            if (keyStartStop === 'Y') {
                disableInput(totalHoursInput);
                enableInput(startTimeInput);
                enableInput(endTimeInput);              
                if ($.session.useSystemTimeClockInOut === 'Y' && isAdminEdit !== true) {
                    var messagetext = document.getElementById('systemMessage');
                    messagetext.innerHTML = '*Your organization does not allow for time edit. Only system time may be used.';
                    disableInput(startTimeInput);
                    disableInput(endTimeInput);
                    disableInput(dateInput);
                    var endInput = endTimeInput.querySelector('input');
                    if (isEdit && (endInput.value == null || endInput.value == '')) {
                        disableInput(startTimeInput);
                        enableInput(endTimeInput);
                    }
                }
                if ($.session.useSystemTimeClockInOut === 'Y' && isAdminEdit === true && $.session.SingleEntryEditTimeEntry !== true) {
                    var messagetext = document.getElementById('systemMessage');
                    messagetext.innerHTML = '*Your organization does not allow for time edit. Only system time may be used.';
                }
            } else {
                enableInput(totalHoursInput);
                disableInput(startTimeInput);
                disableInput(endTimeInput);
            }
        }

        // Save, Delete & Cancel Buttons
        if (isEdit) {
            if (
                $.session.editSingleEntryCardStatus === 'S' ||
                $.session.editSingleEntryCardStatus === 'I' ||
                $.session.SingleEntryUpdate === false
            ) {
                saveBtn.classList.add('disabled');           
                saveAndSumbitBtn.classList.add('disabled');
            } else {
                if ($.session.disableSESaveGEOLocation === false) {
                    saveBtn.classList.remove('disabled');
                    saveAndSumbitBtn.classList.remove('disabled');
                }
                deleteBtn.classList.remove('disabled');
            }
        }

        checkRequiredFields();

        if (isEndTimeChangePermission) {
            disableInput(startTimeInput);
            disableInput(totalHoursInput);
            enableInput(endTimeInput);

            disableInput(locationDropdown);
            disableInput(dateInput);
            disableInput(workCodeDropdown);
            if (reasonDropdown) disableInput(reasonDropdown);
            if (licenseplateInput) disableInput(licenseplateInput);
            if (locationTypeDropdown) disableInput(locationTypeDropdown);

            dateInput.classList.remove('error');
            noteInput.classList.remove('error');
            workCodeDropdown.classList.remove('error');
            startTimeInput.classList.remove('error');
            endTimeInput.classList.remove('error');

            deleteBtn.classList.remove('disabled');

            if (endTime != null && endTime < startTime) {
                endTimeInput.classList.add('error');
                saveBtn.classList.add('disabled');
                saveAndSumbitBtn.classList.add('disabled');
            } else {
                endTimeInput.classList.remove('error');
                saveBtn.classList.remove('disabled');
                saveAndSumbitBtn.classList.remove('disabled');
            }
        }
    }
    // Events
    //------------------------------------
    function setupCardEvents() {
        if (!isEdit) {
            payPeriodDropdown.addEventListener('change', event => {
                const selectedOption = event.target.options[event.target.selectedIndex];
                var dateRange = event.target.value.split(' - ');
                var startDateIso = UTIL.formatDateToIso(dateRange[0]);
                var endDateIso = UTIL.formatDateToIso(dateRange[1]);
                sendEvvData = selectedOption.dataset.sendevv;
                payPeriod = timeEntry.setSelectedPayPeriod(startDateIso, endDateIso, event.target.value);
                updateDateValMinMax();
            });
        } else {
            deleteBtn.addEventListener('click', event => {
                var warningMessage = `This entry will be permanently deleted, do you wish to continue?`;
                timeEntryReview.showDeleteEntryWarningPopup(warningMessage, () =>
                    timeEntry.deleteEntry(singleEntryId, isAdminEdit, payPeriod),
                );
            });
            deleteBtn.addEventListener('keydown', e => {
                if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.altKey) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        }

        locationDropdown.addEventListener('change', event => {
            locationId = event.target.value;
            setAllowedConsumers();
            clearConsumerSection();
            checkPermissions();
        });
        locationDropdown.addEventListener('keydown', e => {
            e.preventDefault();
            e.stopPropagation();
        });
        reasonDropdown.addEventListener('change', event => {
            evvReasonCode = event.target.value;
            checkPermissions();
        });
        reasonDropdown.addEventListener('keydown', e => {
            e.preventDefault();
            e.stopPropagation();
        });
        locationTypeDropdown.addEventListener('change', event => {
            locationTypeCode = event.target.value;
            checkPermissions();
        });
        locationTypeDropdown.addEventListener('keydown', e => {
            e.preventDefault();
            e.stopPropagation();
        });
        attestCheckbox.addEventListener('change', event => {
            checkAttestStatus();
        });
        attestCheckbox.addEventListener('keydown', e => {
            e.preventDefault();
            e.stopPropagation();
        });
        workCodeDropdown.addEventListener('change', event => workCodeDropdownEvent(event));
        workCodeDropdown.addEventListener('keydown', e => {
            e.preventDefault();
            e.stopPropagation();
        });
        dateInput.addEventListener('change', event => {
            entryDate = event.target.value;
            roster2.updateSelectedDate(entryDate);
            evvCheckConsumerEligibilityExistingConsumers();
            checkPermissions();
        });
        dateInput.addEventListener('keydown', event => {
            event.preventDefault();
            event.stopPropagation();
        });
        startTimeInput.addEventListener('focusout', async event => {
            var hoursInput = totalHoursInput.querySelector('input');
            var isTimeValid = UTIL.validateTime(event.target.value);
            if (!isTimeValid) {
                hoursInput.value = '';
                checkPermissions();
                return;
            }

            const origStartTime = startTime;
            startTime = `${event.target.value.split(':')[0]}:${event.target.value.split(':')[1]}`;
            if ($.session.singleEntry15minDoc === 'Y' && origStartTime !== startTime) {
                var min = parseInt(startTime.split(':')[1]);
                if (min % 15 !== 0) {
                    errorPopup('This is not a valid time, you must document to the nearest quarter hour.');
                    event.target.value = '';
                    startTime = '0';
                }
            }

            if (origStartTime !== startTime) defaultTimesChanged = true;
            if (origStartTime !== startTime) {
                defaultStartTimeChanged = true;
                reasonRequired = true; // for evv
            } else {
                defaultStartTimeChanged = false;
                reasonRequired = false;
            }

            if (isEdit && defaultStartTimeChanged) {
                if (evvDateCheck) {
                    // reason input is show instead of reason dropdown
                } else {
                    reasonDropdown.classList.remove('disabled');
                    const reasonCodeDropdown = reasonDropdown.querySelector('select');
                    reasonCodeDropdown.value = '%';
                    evvReasonCode = '%';
                    reasonDropdown.classList.add('error');
                }
            }

            await evvCheck();
            setTotalHours();
            checkPermissions();
            //if ($.session.singleEntryLocationRequired === 'Y') {
            if ($.session.geoLocationEnabled === true) {
                UTIL.getGeoLocation(setStartTimeLocation, true);
            }
        });

        endTimeInput.addEventListener('keydown', event => {
            if ($.session.useSystemTimeClockInOut == 'Y' && isAdminEdit != true) {
                if (isEdit) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        });

        endTimeInput.addEventListener('click', event => {
            setEndTimeOnClick(event);
            if ($.session.useSystemTimeClockInOut == 'Y' && isAdminEdit != true) {
                if (isEdit) {
                    disableInput(startTimeInput);
                    disableInput(endTimeInput);
                }
            }
        });
        endTimeInput.addEventListener('focusout', async event => {
            if ($.session.useSystemTimeClockInOut == 'Y' && isAdminEdit != true) {
                if (isEdit) {
                    event.target.value = UTIL.convertToMilitary(event.target.value);
                }
            }
            var hoursInput = totalHoursInput.querySelector('input');
            var endInput = endTimeInput.querySelector('input');
            var isTimeValid = UTIL.validateTime(event.target.value);
            if (!isTimeValid) {
                $.session.singleEntrycrossMidnight = false;
                //	crossMidnightTimeData = {};
                endInput.value = '';
                endTime = null;
                hoursInput.value = '';
                totalHours = null;
                checkPermissions();
                return;
            }
            var now = new Date();
            let origEndTime = endTime;
            let systemDefaultForCheckEnd = now.getHours() + ':' + now.getMinutes();
            endTime = `${event.target.value.split(':')[0]}:${event.target.value.split(':')[1]}`; //Edge fucks shit up with selecting time with the time picker
            if ($.session.singleEntry15minDoc === 'Y' && origEndTime !== endTime) {
                // and endTime !== event.target.value
                var min = parseInt(endTime.split(':')[1]);
                if (min % 15 !== 0) {
                    errorPopup('This is not a valid time, you must document to the nearest quarter hour.');
                    event.target.value = '';
                    endTime = '0';
                }
            }

            if (origEndTime) {
                origEndTime = `${origEndTime.split(':')[0]}:${origEndTime.split(':')[1]}`;
            }

            if (origEndTime !== endTime) defaultTimesChanged = true;

            // 9:30:00 !== 9:30
            if (systemDefaultForCheckEnd !== endTime) {
                defaultEndTimeChanged = true;
                reasonRequired = true; // for evv
            } else {
                defaultEndTimeChanged = false;
                reasonRequired = false;
            }

            if (isEdit && defaultTimesChanged) {
                if (evvDateCheck) {
                    // reason input is show instead of reason dropdown
                } else {
                    reasonDropdown.classList.remove('disabled');
                    const reasonCodeDropdown = reasonDropdown.querySelector('select');
                    reasonCodeDropdown.value = '%';
                    evvReasonCode = '%';
                    reasonDropdown.classList.add('error');
                }
            }

            await evvCheck();
            setTotalHours();
            checkPermissions();
            //if ($.session.singleEntryLocationRequired === 'Y') {
            if ($.session.geoLocationEnabled === true) {
                UTIL.getGeoLocation(setEndTimeLocation, true);
            }

            if ($.session.useSystemTimeClockInOut == 'Y' && isAdminEdit != true) {
                if (isEdit) {
                    const defaultFormat = now.toLocaleTimeString();
                    if (defaultFormat.includes('AM') || defaultFormat.includes('PM'))
                        event.target.value = UTIL.convertFromMilitary(event.target.value);
                }
            }
        });
        // TOTALHOURSINPUT - changed from keyup to input because using the arrow keys
        // (not on the keyboard but in the input itself) didn't trigger the event listener
        totalHoursInput.addEventListener('input', event => {
            totalHours = event.target.value;
            checkPermissions();
        });
        noteInput.addEventListener('keyup', event => {
            noteText = event.target.value;

            if (isCardDisabled || isCurrentRecordClosed) {
                if (requiredFields.isNoteRequired === 'Y') {
                    if (noteText === '' || !noteText) {
                        noteInput.classList.add('error');
                        saveBtn.classList.add('disabled');
                    } else {
                        noteInput.classList.remove('error');
                        saveBtn.classList.remove('disabled');
                    }
                } else {
                    saveBtn.classList.remove('disabled');
                }
            } else {
                checkPermissions();
            }
        });
        transportationBtn.addEventListener('click', () => {
            buildTransportationPopup();
        });
        transportationBtn.addEventListener('keydown', e => {
            if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.altKey) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
        saveBtn.addEventListener('click', async event => {
            //118744 - ADV-ANY-SE: Add warning to users if services are not documented for
            const undocumentedConsumerIDs = await singleEntryAjax.getUndocumentedServicesForWarning(entryDate, consumerIds);
            if (
                $.session.anyUndocumentedServices === 'Y' &&
                endTime != null &&
                endTime != '' &&
                undocumentedConsumerIDs.length > 0
            ) {
                await undocumentedServicesPopup(event, undocumentedConsumerIDs, 'SAVE');
            } else {
                await saveEvent(event);
            }
        });
        saveBtn.addEventListener('keydown', e => {
            if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.altKey) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
        saveAndSumbitBtn.addEventListener('click', async event => {
            //118744 - ADV - ANY - SE: Add warning to users if services are not documented for
            const undocumentedConsumerIDs = await singleEntryAjax.getUndocumentedServicesForWarning(entryDate, consumerIds);
            if (
                $.session.anyUndocumentedServices === 'Y' &&
                endTime != null &&
                endTime != '' &&
                undocumentedConsumerIDs.length > 0
            ) {
                undocumentedServicesPopup(event, undocumentedConsumerIDs, 'SAVESUBMIT');
            }
            ////////
            else {
                // Save entry first
                await saveAndSubmitEvent(event);
            }
            // TODO, make global so access from timeentry.js
            // event.target.classList.remove('disabled');
            // saveBtn.classList.remove('disabled');
        });
        saveAndSumbitBtn.addEventListener('keydown', e => {
            if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.altKey) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
        cancelBtn.addEventListener('click', () => {
            if (isAdminEdit) {
                timeApproval.refreshPage(payPeriod);
            } else {
                timeEntryReview.refreshPage(payPeriod);
            }
            clearAllGlobalVariables();
        });
    }
    //118744 - ADV-ANY-SE: Add warning to users if services are not documented for
    async function undocumentedServicesPopup(event, undocumentedConsumerIDs, NameOfEvent) {
        const confirmPopup = POPUP.build({
            hideX: true,
            classNames: 'warning',
        });

        YES_BTN = button.build({
            text: 'YES',
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                POPUP.hide(confirmPopup);
                if (NameOfEvent === 'SAVESUBMIT') await saveAndSubmitEvent(event);
                else await saveEvent(event);
            },
        });

        NO_BTN = button.build({
            text: 'NO',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                POPUP.hide(confirmPopup);
            },
        });

        const message = document.createElement('p');
        const messageConfirm = document.createElement('p');
        const vendorSection = document.createElement('div');
        undocumentedConsumerIDs.forEach(consumerName => {
            const vendorDisp = document.createElement('div');
            vendorDisp.innerHTML = `<span>${consumerName}</span>`;
            vendorDisp.classList.add('consumerNameList');
            vendorSection.appendChild(vendorDisp);
        });

        message.innerText =
            'The following individuals have services that you did not document for on the date of your time record.';
        message.style.textAlign = 'left';
        message.style.marginBottom = '15px';
        messageConfirm.innerText = 'Would you like to save this time record?';
        messageConfirm.style.textAlign = 'left';
        messageConfirm.style.marginBottom = '15px';
        confirmPopup.appendChild(message);
        confirmPopup.appendChild(vendorSection);
        confirmPopup.appendChild(messageConfirm);
        var popupbtnWrap = document.createElement('div');
        popupbtnWrap.classList.add('btnWrap');
        popupbtnWrap.appendChild(YES_BTN);
        popupbtnWrap.appendChild(NO_BTN);
        confirmPopup.appendChild(popupbtnWrap);
        YES_BTN.focus();
        POPUP.show(confirmPopup);
    }
    async function saveEvent(event) {
        event.target.classList.add('disabled');
        saveOrUpdate = event.target.dataset.insertType;
        if (saveOrUpdate === 'Save') {
            const result = await singleEntryAjax.getExistingTimeEntry();
            const { getExistingTimeEntryResult } = result;
            if (getExistingTimeEntryResult.length > 0 && $.session.anyRequireEndTime == 'Y') {
                newTimeEntry.endDateWarningPopup(getExistingTimeEntryResult);
            } else {
                timeEntry.getEntryData(keyStartStop);
            }
        }
        if (saveOrUpdate === 'Update') timeEntry.updateEntry(isAdminEdit, payPeriod, keyStartStop);
    }
    async function saveAndSubmitEvent(event) {
        event.target.classList.add('disabled');
        saveBtn.classList.add('disabled');
        saveOrUpdate = event.target.dataset.insertType;

        const saveAndUpdate = true;
        if (saveOrUpdate === 'Save') {
            const result = await singleEntryAjax.getExistingTimeEntry();
            const { getExistingTimeEntryResult } = result;
            if (getExistingTimeEntryResult.length > 0 && $.session.anyRequireEndTime == 'Y') {
                newTimeEntry.endDateWarningPopup(getExistingTimeEntryResult);
            } else {
                timeEntry.getEntryData(keyStartStop, saveAndUpdate);
            }
        }
        if (saveOrUpdate === 'Update') timeEntry.updateEntry(isAdminEdit, payPeriod, keyStartStop, saveAndUpdate);
    }
    function enableSaveButtons() {
        if ($.session.disableSESaveGEOLocation === false) {
            saveBtn.classList.remove('disabled');
            saveAndSumbitBtn.classList.remove('disabled');
        }
    }
    function enableSaveButton() {
        if ($.session.disableSESaveGEOLocation === false) {
            saveBtn.classList.remove('disabled');
        }
    }
    async function customRosterApplyFilterEvent() {
        if (isBillable === 'Y' && !$.session.singleEntryUseServiceLocations) {
            // check if residence === 'N'
            var allowedConsumers = await getAllowedConsumersBasedOffResidence();
            roster2.setAllowedConsumers(allowedConsumers);
        } else {
            // roster.setAllowedConsumers([]);
            // var allowedConsumers = await getAllowedConsumersBasedOffServiceLocations();
            // roster2.setAllowedConsumers(allowedConsumers);
            await setAllowedConsumers();
        }
    }
    async function workCodeDropdownEvent(event) {
        var selectedOption = event.target.options[event.target.selectedIndex];
        workCode = selectedOption.value;
        isBillable = selectedOption.dataset.billable;
        keyStartStop = selectedOption.dataset.keytimes;
        wcServiceType = selectedOption.dataset.servicetype;
        //if (isBillable === 'Y') locationId = undefined;
        updateDateValMinMax(false);

        if (isBillable === 'Y' && !$.session.singleEntryUseServiceLocations) {
            // check if residence === 'N'
            var allowedConsumers = await getAllowedConsumersBasedOffResidence();
            roster2.setAllowedConsumers(allowedConsumers);
        } else {
            // roster.setAllowedConsumers([]);
            var allowedConsumers = await getAllowedConsumersBasedOffServiceLocations();
            roster2.setAllowedConsumers(allowedConsumers);
        }

        var miniRosterBtn = document.querySelector('.consumerListBtn');
        if (miniRosterBtn) {
            if (isBillable === 'Y') {
                miniRosterBtn.classList.remove('disabled');
            } else {
                miniRosterBtn.classList.add('disabled');
                clearConsumerSection();
            }
        }

        clearCard();
        // Set start time after card gets cleared
        if (keyStartStop === 'Y') {
            if (
                $.session.useSystemTimeClockInOut == 'N' ||
                ($.session.useSystemTimeClockInOut == 'Y' && isAdminEdit != true && !isEdit)
            ) {
                startTimeInput.getElementsByTagName('input')[0].value = `${nowHour}:${nowMinutes}`;
                startTime = `${nowHour}:${nowMinutes}`;
            }
            //if ($.session.singleEntryLocationRequired === 'Y') {//
            if ($.session.geoLocationEnabled === true) {
                UTIL.getGeoLocation(setStartTimeLocation, true);
            }
        }

        checkPermissions();
    }
    function setEndTimeOnClick(event) {
        if (endTimeClicks !== 0 || event.target.value !== '') return;
        endTimeClicks = 1;
        let tempEndTime = new Date();
        let endTimeHour = tempEndTime.getHours() < '10' ? `0${now.getHours()}` : tempEndTime.getHours();
        let endTimeMinute = tempEndTime.getMinutes() < '10' ? `0${now.getMinutes()}` : tempEndTime.getMinutes();
        event.target.value = `${endTimeHour}:${endTimeMinute}`;

        if ($.session.useSystemTimeClockInOut == 'Y' && isAdminEdit != true) {
            if (isEdit) {
                const defaultFormat = now.toLocaleTimeString();
                if (defaultFormat.includes('AM') || defaultFormat.includes('PM'))
                    event.target.value = UTIL.convertFromMilitary(`${endTimeHour}:${endTimeMinute}`);
            }
        }
        endTime = `${endTimeHour}:${endTimeMinute}`;
        //if ($.session.singleEntryLocationRequired === 'Y') {
        if ($.session.geoLocationEnabled === true) {
            UTIL.getGeoLocation(setEndTimeLocation, true);
        }
        setTotalHours();
        checkPermissions();
    }

    // Populate
    //------------------------------------
    function populatePayPeriodDropdown() {
        var dropdownData = payPeriodData
            .filter(pp => pp.anywhereClosed !== 'True')
            .map(pp => {
                var dateArray = pp.dateString.split(' - ');
                var startDate = dateArray[0];
                var endDate = dateArray[1];

                var startDateAbbr = UTIL.abbreviateDateYear(startDate);
                var endDateAbbr = UTIL.abbreviateDateYear(endDate);
                return {
                    value: `${startDate} - ${endDate}`,
                    text: `${startDateAbbr} - ${endDateAbbr}`,
                    attributes: [{ key: 'data-sendEvv', value: pp.sendEvvData }],
                };
            });
        sendEvvData = dropdownData[0].attributes[0].value;
        dropdown.populate(payPeriodDropdown, dropdownData, payPeriod.dateString);
    }
    function populateLocationDropdown() {
        // ID, Name, Residence, SE_Trans_Reimbursable
        var dropdownData = locationData.map(loc => {
            return {
                value: loc.ID,
                text: loc.Name,
            };
        });

        dropdownData.unshift({ value: '%', text: '' });

        dropdown.populate(locationDropdown, dropdownData, locationId);
    }
    function populateWorkCodeDropdown() {
        var wcData;

        if (isEdit) {
            wcData = workCodeData.filter(
                wc => wc.billable === isBillable && (wc.active === 'Y' || wc.workcodeid == workCode),
            );
        } else {
            wcData = workCodeData.filter(wc => wc.active === 'Y');
        }

        var dropdownData = wcData.map(wc => {
            return {
                value: wc.workcodeid,
                text: wc.workcodename,
                attributes: [
                    { key: 'data-billable', value: wc.billable },
                    { key: 'data-keyTimes', value: wc.keyTimes },
                    { key: 'data-serviceType', value: wc.serviceType },
                ],
            };
        });

        dropdownData.unshift({ value: '%', text: '' });

        dropdown.populate(workCodeDropdown, dropdownData, workCode);
    }
    function populateReasonCodeDropdown() {
        if ($.session.stateAbbreviation === 'OH') {
            dropdown.populate(
                reasonDropdown,
                [
                    { value: '%', text: '' },
                    { value: '99', text: '99 - Documentation on file supports manual change' },
                ],
                evvReasonCode,
            );

            if (evvReasonCode === '99') {
                reasonCodeValue = '99 - Documentation on file supports manual change';
            }
        } else {
            const dropdownData = evvReasonCodeObj.map(reason => {
                return {
                    value: reason.reasonCode,
                    text: `${reason.reasonCode} - ${reason.reasonDescription}`,
                };
            });
            dropdownData.unshift({ value: '%', text: '' });
            dropdown.populate(reasonDropdown, dropdownData, evvReasonCode);

            if (evvReasonCode == null || evvReasonCode == '%' || evvReasonCode == undefined || evvReasonCode == '99') {
                evvReasonCode = '99';
                reasonCodeValue = '99 - Documentation on file supports manual change';
            } else {
                reasonCodeValue = dropdownData.find(x => x.value == evvReasonCode).text;
            }
        }

        // if (document.getElementById('reasonInput') != null && document.getElementById('reasonInput') != undefined) {
        //     if (!reasonCodeValue) {
        //         reasonCodeValue = '99 - Documentation on file supports manual change';
        //         evvReasonCode = '99';
        //     }
        //     document.getElementById('reasonInput').value = reasonCodeValue;
        // }

        populateLocationTypeDropdown();
    }
    function populateReasonInput() {
        const reasonInput = document.getElementById('reasonInput');
        if (reasonInput) {
            if (!reasonCodeValue) {
                reasonCodeValue = '99 - Documentation on file supports manual change';
            }
            if (!evvReasonCode) {
                evvReasonCode = '99';
            }
            reasonInput.value = reasonCodeValue;
        }
    }
    function populateLocationTypeDropdown() {
        const locationTypeDropdownData = [
            { id: 1, value: 1, text: '1 - Home' },
            { id: 2, value: 2, text: '2 - Community' },
        ];
        dropdown.populate(locationTypeDropdown, locationTypeDropdownData, locationTypeCode);
    }
    async function populateCard(useAllWorkCodes) {
        payPeriodData = timeEntry.getPayPeriods(false);
        locationData = timeEntry.getLocations();
        workCodeData = await timeEntry.getWorkCodes(useAllWorkCodes);
        requiredFields = timeEntry.getRequiredFields();
        evvReasonCodeObj = timeEntry.getEvvReasonCodes();

        endTimeClicks = 0;
        now = new Date();
        nowHour = now.getHours() < '10' ? `0${now.getHours()}` : now.getHours();
        nowMinutes = now.getMinutes() < '10' ? `0${now.getMinutes()}` : now.getMinutes();

        if (!isEdit) populatePayPeriodDropdown();
        populateLocationDropdown();
        populateWorkCodeDropdown();

        setupCardEvents();
        checkPermissions();
        if (defaultTimesChanged) showEvv();

        if (isAdminEdit) {
            if (!$.session.SingleEntryEditTimeEntry) {
                isCardDisabled = true;
                saveBtn.classList.add('disabled');
                deleteBtn.classList.add('disabled');
            } else {
                if (status === 'A' || status === 'S' || status === 'I' || (!$.session.SingleEntryUpdate && isEdit)) {
                    if ($.session.SingleEntryEditTimeEntry && status === 'A') {
                        isCardDisabled = false;
                    } else {
                        isCardDisabled = true;
                    }
                } else if (status === 'R' || status === 'D') {
                    isCardDisabled = true;
                }
            }
        } else {
            if (
                status === 'A' ||
                status === 'S' ||
                status === 'I' ||
                status === 'D' ||
                (!$.session.SingleEntryUpdate && isEdit)
            ) {
                isCardDisabled = true;
            }
        }

        if (status === 'I' || status === 'D' || status === 'S' || isCurrentRecordClosed) {
            if (isTransportationValid) {
                transportationBtn.classList.remove('disabled');
            } else {
                transportationBtn.classList.add('disabled');
            }
        } else {
            transportationBtn.classList.remove('disabled');
        }

        if (isCardDisabled) {
            saveBtn.classList.add('disabled');
            saveAndSumbitBtn.classList.add('disabled');
            if (status !== 'R') {
                deleteBtn.classList.add('disabled');
            }
            else {
                deleteBtn.classList.remove('disabled');
            }
            workCodeDropdown.classList.add('disabled');
            locationDropdown.classList.add('disabled');
            startTimeInput.classList.add('disabled');
            endTimeInput.classList.add('disabled');
            reasonDropdown.classList.add('disabled');
            attestCheckbox.classList.add('disabled');
            dateInput.classList.add('disabled');
            rejectionReasonInput.classList.add('disabled');

            roster2.toggleMiniRosterBtnVisible(false);
        }

        // initially when editing a rejected/Non-Billable, the Save btns are disabled, they become enabled after the first edit of the form
        if (status === 'R' && (personId === $.session.PeopleId || supervisorId === $.session.PeopleId)) {
            saveBtn.classList.add('disabled');
            saveAndSumbitBtn.classList.add('disabled');
        }

        if (isEndTimeChangePermission) {
            workCodeDropdown.classList.add('disabled');
            locationDropdown.classList.add('disabled');
            startTimeInput.classList.add('disabled');
            endTimeInput.classList.remove('disabled');
            reasonDropdown.classList.add('disabled');
            attestCheckbox.classList.add('disabled');
            dateInput.classList.add('disabled');
            rejectionReasonInput.classList.add('disabled');
            locationTypeDropdown.classList.add('disabled');

            saveBtn.classList.add('disabled');
            saveAndSumbitBtn.classList.add('disabled');
            deleteBtn.classList.remove('disabled');

            dateInput.classList.remove('error');
            endTimeInput.classList.remove('error');

            roster2.toggleMiniRosterBtnVisible(false);
        }
    }

    // EVV
    // -----------------------------------
    function checkTimeForAfterNow(enteredTime) {
        let tempNow = new Date();
        let nowHour = tempNow.getHours() < '10' ? `0${now.getHours()}` : tempNow.getHours();
        let nowMinuet = tempNow.getMinutes() < '10' ? `0${now.getMinutes()}` : tempNow.getMinutes();
        return Date.parse(`01/01/2020 ${enteredTime}`) > Date.parse(`01/01/2020 ${nowHour}:${nowMinuet}`);
    }

    async function evvCheck() {
        if (!isEdit) {
            if (startTime) {
                await evvCheckConsumerEligibilityExistingConsumers();
                if (
                    isBillable === 'Y' &&
                    defaultTimesChanged &&
                    wcServiceType === 'A' &&
                    sendEvvData === 'Y' &&
                    (reasonRequired === true || isEVVSingleEntry)
                ) {
                    showEvv();
                } else {
                    hideEvv();
                }
            }
        } else {
            //isEdit is true
            // Added the below code because the functionality was breaking due to workCodeData not being loaded when the page rendered for the first time.
            if (!workCodeData)
                workCodeData = await timeEntry.getWorkCodes(true);
            let wcObj = workCodeData.filter(wc => wc.workcodeid === workCode);
            wcServiceType = wcObj[0].serviceType;
            let ppObj = payPeriodData.filter(pp => pp.dateString === payPeriod.dateString);
            sendEvvData = ppObj[0].sendEvvData;
            await evvCheckConsumerEligibilityExistingConsumers();
            if (
                isBillable === 'Y' &&
                defaultTimesChanged &&
                wcServiceType === 'A' &&
                sendEvvData === 'Y' &&
                (reasonRequired === true || isEVVSingleEntry)
            ) {
                if (defaultEndTimeChanged || defaultTimesChanged) {
                    showEvv();
                } else {
                    hideEvv();
                }
            } else {
                hideEvv();
            }
        }
    }

    async function evvCheckConsumerEligibility(id) {
        const res = await singleEntryAjax.getEvvEligibilityAsync(id, entryDate);
        if (res.length > 0) {
            eligibleConsumersObj[id] = true;
            reasonRequired = true;
        } else {
            eligibleConsumersObj[id] = false;
        }

        await evvCheck();
    }

    async function evvCheckConsumerEligibilityExistingConsumers() {
        reasonRequired = false;
        consumerIds.forEach(async id => {
            const res = await singleEntryAjax.getEvvEligibilityAsync(id, entryDate);
            if (res.length > 0) {
                reasonRequired = true;
                eligibleConsumersObj[id] = true;
                isEVVSingleEntry = true;
            } else {
                eligibleConsumersObj[id] = false;
            }
            disableCardFields();

            if (
                isEVVSingleEntry &&
                sendEvvData === 'Y' &&
                eVVChangeDate != '' &&
                $.session.stateAbbreviation == 'OH' &&
                todayDate >= eVVChangeDate
            ) {
                populateLocationTypeDropdown();
                locationTypeDropdown.style.display = 'flex';
                locationTypeCode = '1';

                if ((isAdminEdit || isEdit) && status !== 'D' && status !== 'I' && status !== 'S' && (status !== 'A' || (status === 'A' && supervisorId === $.session.PeopleId))) {
                    evvEnableDisabledInputs();
                }
                if ((isAdminEdit || isEdit) && (status === 'I' || status === 'S')) {
                    if (startTimeInput) disableInput(startTimeInput);
                    if (endTimeInput) disableInput(endTimeInput);
                }
                if ((isAdminEdit || isEdit) && (status === 'I' || status === 'S' || status === 'A' || status === 'D')) {
                    if (locationTypeDropdown) disableInput(locationTypeDropdown);
                }
            }
        });
    }
    // under following conditions, the form imputs disabled (except time inputs): 1) entry is rejected, 2) workcode = Billable, 3) user is creator/supervisor, 4) this entry requires EVV
    function disableCardFields() {
        if (
            isEVVSingleEntry &&
            isEdit &&
            isBillable &&
            (personId === $.session.PeopleId || supervisorId === $.session.PeopleId)
        ) {
            roster2.toggleMiniRosterBtnVisible(false);
            workCodeDropdown.classList.add('disabled');
            locationDropdown.classList.add('disabled');
            attestCheckbox.classList.add('disabled');
            dateInput.classList.add('disabled');
            rejectionReasonInput.classList.add('disabled');
        }
    }

    async function evvCheckRemainingConsumers() {
        reasonRequired = false;
        consumerIds.forEach(id => {
            if (eligibleConsumersObj[id]) reasonRequired = true;
        });
        await evvCheck();
        checkAttestStatus();
    }

    function showEvv() {
        if (evvDateCheck) {
            locationTypeDropdown.style.display = 'flex';
            attestCheckbox.style.display = 'inline-flex';
            reasonInput.style.display = 'flex';

            if ((isAdminEdit || isEdit) && status !== 'D' && status !== 'I' && status !== 'S' && (status !== 'A' || (status === 'A' && supervisorId === $.session.PeopleId))) {
                evvEnableDisabledInputs();
            }
            if ((isAdminEdit || isEdit) && (status === 'I' || status === 'S')) {
                if (startTimeInput) disableInput(startTimeInput);
                if (endTimeInput) disableInput(endTimeInput);
            }
            if ((isAdminEdit || isEdit) && (status === 'I' || status === 'S' || status === 'A' || status === 'D')) {
                if (locationTypeDropdown) disableInput(locationTypeDropdown);
            }

            if (!locationTypeCode) {
                locationTypeCode = '1';
            }

            populateReasonInput();
        } else {
            reasonDropdown.style.display = 'flex';
            populateReasonCodeDropdown();
        }

        // populateReasonCodeDropdown();
        // document.querySelector('.timeCard__evv').style.display = 'flex';
        // document.querySelector('.timeCard__evvattestChk').style.display = 'flex';
        // if (eVVChangeDate != '' && $.session.stateAbbreviation === 'OH' && todayDate >= eVVChangeDate) {
        //     document.querySelector('.timeCard__LocationEvv').style.display = 'flex';
        //     if (!locationTypeCode) {
        //         locationTypeCode = '1';
        //     }
        // }
    }
    function evvEnableDisabledInputs() {
        if (noteInput) enableInput(noteInput);
        if (startTimeInput) enableInput(startTimeInput);
        if (endTimeInput) enableInput(endTimeInput);

        if (dateInput) disableInput(dateInput);
        if (totalHoursInput) disableInput(totalHoursInput);
        if (locationDropdown) disableInput(locationDropdown);
        if (workCodeDropdown) disableInput(workCodeDropdown);
        if (licenseplateInput) disableInput(licenseplateInput);
        if (reasonDropdown) disableInput(reasonDropdown);
        if (locationTypeDropdown) disableInput(locationTypeDropdown);
    }
    function hideEvv() {
        reasonRequired = false;

        if (evvDateCheck && !isEdit) {
            reasonInput.style.display = 'none';
        } else {
            reasonDropdown.style.display = 'none';
        }

        //attestCheckbox.style.display = 'inline-flex';

        // populateReasonCodeDropdown();
        // document.querySelector('.timeCard__evv').style.display = 'flex';
        // document.querySelector('.timeCard__evvattestChk').style.display = 'flex';
        // if (eVVChangeDate != '' && $.session.stateAbbreviation === 'OH' && todayDate >= eVVChangeDate) {
        //     document.querySelector('.timeCard__LocationEvv').style.display = 'flex';
        //     if (!locationTypeCode) {
        //         locationTypeCode = '1';
        //     }
        // }
    }

    function checkAttestStatus() {
        if (reasonRequired && attestCheckbox.getElementsByTagName('input')[0].checked === false) {
            attestCheckbox.classList.add('redButNotError');
        } else {
            attestCheckbox.classList.remove('redButNotError');
        }
    }

    // Build
    //------------------------------------
    // dropdowns
    function buildPayPeriodDropdown() {
        return dropdown.build({
            dropdownId: 'payPeriodsDropdown',
            label: 'Pay Period',
            style: 'secondary',
            readonly: false,
        });
    }
    function buildLocationDropdown() {
        return dropdown.build({
            dropdownId: 'locationsDropodown',
            label: 'Location',
            style: 'secondary',
            readonly: isEdit ? true : false,
        });
    }
    function buildWorkCodeDropdown() {
        return dropdown.build({
            dropdownId: 'workCodesDropdown',
            label: 'Work Code',
            style: 'secondary',
            readonly: false,
        });
    }
    function buildEVVReasonDropdown() {
        return dropdown.build({
            dropdownId: 'reasonDropdown',
            label: 'Reason Code',
            style: 'secondary',
            readonly: false,
        });
    }

    function buildLocationTypeDropdown() {
        return dropdown.build({
            dropdownId: 'locationTypeDropdown',
            label: 'Location Type',
            style: 'secondary',
            readonly: false,
        });
    }

    function buildEVVReasontext() {
        return input.build({
            id: 'reasonInput',
            type: 'text',
            label: 'Reason Code',
            style: 'secondary',
            value: reasonCodeValue,
            readonly: true,
        });
    }
    // inputs
    function buildDateInput() {
        var dateObj = new Date(entryDate);
        var minDate;
        var maxDate;
        if (isEdit) {
            if (isBillable === 'Y') {
                minDate = entryDate;
                maxDate = entryDate;
            } else {
                // minDate = UTIL.getFormattedDateFromDate(dates.startDayOfWeek(dateObj), { separator: '-', format: 'iso' });
                // maxDate = UTIL.getFormattedDateFromDate(dates.endOfWeek(dateObj), { separator: '-', format: 'iso' });
                minDate = payPeriod.start;
                maxDate = payPeriod.end;
            }
        } else {
            //NEW
            if (isBillable === 'Y') {
                minDate = payPeriod.start;
                maxDate = entryDate;
            } else {
                minDate = payPeriod.start;
                maxDate = payPeriod.end;
            }
        }
        return input.build({
            id: 'dateBox',
            label: 'Date',
            type: 'date',
            style: 'secondary',
            value: entryDate,
            attributes: [
                {
                    key: 'min',
                    value: minDate,
                },
                {
                    key: 'max',
                    value: maxDate,
                },
            ],
        });
    }
    function buildStartTimeInput() {
        return (startTimeInput = input.build({
            label: 'Start Time',
            type: 'time',
            style: 'secondary',
            attributes: [{ key: 'step', value: $.session.singleEntry15minDoc === 'Y' ? '900' : '60' }],
            value: startTime,
        }));
    }
    function buildEndTimeInput() {
        let endTimeValue = endTime;
        if ($.session.useSystemTimeClockInOut == 'Y' && isAdminEdit != true) {
            if (isEdit) {
                var now = new Date();
                const defaultFormat = now.toLocaleTimeString();
                if (defaultFormat.includes('AM') || defaultFormat.includes('PM'))
                    endTimeValue = UTIL.convertFromMilitary(endTime);
            }
        }
        return (endTimeInput = input.build({
            label: 'End Time',
            type: $.session.useSystemTimeClockInOut == 'Y' && isAdminEdit != true && isEdit ? 'text' : 'time',
            style: 'secondary',
            attributes: [{ key: 'step', value: $.session.singleEntry15minDoc === 'Y' ? '900' : '60' }],
            value: endTimeValue,
        }));
    }
    function buildTotalHoursInput() {
        return (totalHoursInput = input.build({
            label: 'Hours',
            type: 'number',
            style: 'secondary',
            value: totalHours,
            attributes: [{ key: 'min', value: '0' }],
        }));
    }
    function buildNoteInput() {
        return (noteInput = input.build({
            label: 'Note',
            style: 'secondary',
            type: 'textarea',
            classNames: 'autosize',
            value: noteText,
        }));
    }
    function buildRejectionReasonInput() {
        return (rejectionReasonInput = input.build({
            id: 'rejectionReason',
            label: 'Rejection Reason',
            style: 'secondary',
            type: 'textarea',
            value: rejectionReason,
        }));
    }
    function buildAttestCheckbox() {
        return (attestCheckbox = input.buildCheckbox({
            text: 'Attest',
            style: 'secondary',
            isChecked: evvAttest ? (evvAttest === 'Y' ? true : false) : true,
        }));
    }

    function buildCommunityCheckbox() {
        return (communityCheckbox = input.buildCheckbox({
            text: 'Community',
            style: 'secondary',
            isChecked: evvCommunity === 'Y' ? true : false,
        }));
    }

    // main sections
    function buildTimeEntrySection() {
        var section = document.createElement('div');
        section.classList.add('timeCard__timeEntry');
        // dropdowns
        if (!isEdit) payPeriodDropdown = buildPayPeriodDropdown();
        locationDropdown = buildLocationDropdown();
        workCodeDropdown = buildWorkCodeDropdown();
        reasonDropdown = buildEVVReasonDropdown();
        locationTypeDropdown = buildLocationTypeDropdown();
        // inputs
        reasonInput = buildEVVReasontext();
        dateInput = buildDateInput();
        startTimeInput = buildStartTimeInput();
        endTimeInput = buildEndTimeInput();
        totalHoursInput = buildTotalHoursInput();
        communityCheckbox = buildCommunityCheckbox();
        noteInput = buildNoteInput();
        rejectionReasonInput = buildRejectionReasonInput();
        attestCheckbox = buildAttestCheckbox();
        // transportation
        transportationBtn = buildTransportationBtn();

        var wrap1 = document.createElement('div'); // dates
        var wrap2 = document.createElement('div'); // dropdowns
        var wrap3 = document.createElement('div'); // times
        var wrap7 = document.createElement('div'); // evv
        wrap1.classList.add('timeCard__date');
        wrap2.classList.add('timeCard__other');
        wrap3.classList.add('timeCard__time');
        wrap7.classList.add('timeCard__evv');

        //rejection reason should always be disabled!
        rejectionReasonInput.classList.add('disabled');

        // date wrap
        if (!isEdit) wrap1.appendChild(payPeriodDropdown);
        wrap1.appendChild(dateInput);
        // dropdown wrap
        wrap2.appendChild(workCodeDropdown);
        wrap2.appendChild(locationDropdown);
        // time wrap
        wrap3.appendChild(startTimeInput);
        wrap3.appendChild(endTimeInput);

        if ($.session.stateAbbreviation === 'IN') {
            wrap3.appendChild(communityCheckbox);
        }

        wrap3.appendChild(totalHoursInput);

        var systemMessage = document.createElement('div');
        systemMessage.innerHTML = `<p id="systemMessage" class="systemMessage"></p>`;

        // evv wrap
        // hide evv stuff initially
        if (evvDateCheck) {
            wrap7.appendChild(reasonInput);
            wrap7.appendChild(locationTypeDropdown);
            wrap7.appendChild(attestCheckbox);
        } else {
            wrap7.appendChild(reasonDropdown);
        }

        if (defaultTimesChanged) {
            if (evvDateCheck) {
                locationTypeDropdown.style.display = 'flex';

                if ((isAdminEdit || isEdit) && status !== 'D' && status !== 'I' && status !== 'S' && (status !== 'A' || (status === 'A' && supervisorId === $.session.PeopleId))) {
                    evvEnableDisabledInputs();
                }
                if ((isAdminEdit || isEdit) && (status === 'I' || status === 'S')) {
                    if (startTimeInput) disableInput(startTimeInput);
                    if (endTimeInput) disableInput(endTimeInput);
                }
                if ((isAdminEdit || isEdit) && (status === 'I' || status === 'S' || status === 'A' || status === 'D')) {
                    if (locationTypeDropdown) disableInput(locationTypeDropdown);
                }
                 
                attestCheckbox.style.display = 'inline-flex';
                reasonInput.style.display = 'flex';
            } else {
                reasonDropdown.style.display = 'flex';
            }
        } else {
            if (evvDateCheck) {
                locationTypeDropdown.style.display = 'none';
                attestCheckbox.style.display = 'none';
                reasonInput.style.display = 'none';
            } else {
                reasonDropdown.style.display = 'none';
            }
        }
        section.appendChild(wrap1);
        section.appendChild(wrap2);
        section.appendChild(wrap3);
        section.appendChild(systemMessage);
        section.appendChild(wrap7);
        section.appendChild(noteInput);
        if (status === 'R') {
            section.appendChild(rejectionReasonInput);
        }

        $.session.singleEntryShowTransportation === 'Y' ? section.appendChild(transportationBtn) : ''; //Show Transportation system preference

        return section;
    }
    async function buildConsumerSection(consumersPresent) {
        var section = document.createElement('div');
        section.classList.add('timeCard__consumers');

        var consumerSectionError = document.createElement('div');
        consumerSectionError.classList.add('consumerSectionError');

        section.appendChild(consumerSectionError);

        roster2.clearActiveConsumers(); // clear any previous active consumers

        if (consumersPresent && consumersPresent.length > 0) {
            consumersPresent.forEach(async cp => {
                var splitName = cp.consumername.split(',');
                var consumer = roster2.buildConsumerCard({
                    FN: splitName[0],
                    LN: splitName[1],
                    id: cp.consumerid,
                });
                roster2.addConsumerToActiveConsumers(consumer);
                var card = buildConsumerCard(consumer, cp);
                section.appendChild(card);
                consumerIds.push(cp.consumerid);
                numberOfConsumersPresent = consumerIds.length;
                await evvCheckConsumerEligibility(cp.consumerid);
            });
        }

        return section;
    }
    function buildSaveDeleteCancelButtons() {
        var saveOrUpdate = isEdit ? 'Update' : 'Save';

        saveBtn = button.build({
            text: saveOrUpdate,
            style: 'secondary',
            type: 'contained',
            classNames: ['disabled'],
            attributes: [{ key: 'data-insert-type', value: saveOrUpdate }],
        });
        saveAndSumbitBtn = button.build({
            text: `${saveOrUpdate} and submit`,
            style: 'secondary',
            type: 'contained',
            classNames: ['disabled'],
            attributes: [{ key: 'data-insert-type', value: saveOrUpdate }],
        });
        deleteBtn = button.build({
            text: 'Delete',
            style: 'secondary',
            type: 'outlined',
            classNames: ['disabled'],
        });
        cancelBtn = button.build({
            text: 'Cancel',
            style: 'secondary',
            type: 'outlined',
        });

        var btnWrap = document.createElement('div');
        btnWrap.classList.add('timeCard__actions');

        btnWrap.appendChild(saveBtn);
        btnWrap.appendChild(saveAndSumbitBtn);
        if (isEdit) btnWrap.appendChild(deleteBtn);
        btnWrap.appendChild(cancelBtn);

        return btnWrap;
    }

    async function buildCard(options, editData, consumersPresent, payperiod, isOnlyEndTimeChangePermission = false) {
        // default location code
        setActiveModuleAttribute('timeEntry');
        let defaultTimeEntryLocation = defaults.getLocation('timeEntry');
        let defaultTimeEntryGroup = defaults.getLocation('timeEntryGroup');
        let defaultTimeEntryGroupName = defaults.getLocation('timeEntryGroupName');

        if (defaultTimeEntryLocation === '' || defaultTimeEntryLocation == null) {
            defaults.setLocation('timeEntry', 0);
            defaultTimeEntryLocation = '0';
        }
        defaultTimeEntryGroup = defaultTimeEntryGroup == null ? '' : defaultTimeEntryGroup;
        await roster2.miniRosterinit({
            locationId: defaultTimeEntryLocation,
            locationName: '',
            groupId: defaultTimeEntryGroup,
            groupName: defaultTimeEntryGroupName,
        });
        roster2.toggleMiniRosterBtnVisible(false);
        // options = {isEdit}
        saveUserId = null;
        personId = null;
        var opts = options;
        isEdit = opts.isEdit;
        isAdminEdit = opts.isAdminEdit;

        eVVChangeDate =
            $.session.ohioEVVChangeDate !== '' ? new Date($.session.ohioEVVChangeDate.split('-').join('/')) : '';
        todayDate = new Date(UTIL.getTodaysDate().split('-').join('/'));
        evvDateCheck = eVVChangeDate !== '' && $.session.stateAbbreviation === 'OH' && todayDate >= eVVChangeDate;

        isEndTimeChangePermission = isOnlyEndTimeChangePermission;
        if (editData && editData.length > 0) {
            await setEditDataValues(editData);
            payPeriod = payperiod;
            if (consumersPresent.length > 0) evvReasonCode = consumersPresent[0].evvReasonCode;
            if (evvReasonCode) defaultTimesChanged = true;
            if (isBillable === 'N') {
                roster2.toggleMiniRosterBtnVisible(false);
            } else roster2.toggleMiniRosterBtnVisible(true);
            // evvAttest = editData.attest
        } else {
            entryDate = timeEntry.getCurrentDate(false);
            roster2.updateSelectedDate(entryDate);
            payPeriod = timeEntry.getCurrentPayPeriod(false);
        }

        if ((isEdit || isAdminEdit) && isTransportationValid) {
            transportationSaved = true;
        } else {
            transportationSaved = false;
        }

        await setAllowedConsumers();

        consumerIds = [];
        eligibleConsumersObj = {};

        card = document.createElement('div');
        card.classList.add('card', 'timeCard');

        var cardHeader = document.createElement('div');
        cardHeader.classList.add('card__header');
        var heading = isEdit ? 'Edit Time Entry' : 'New Time Entry';
        cardHeader.innerHTML = `<h3>${heading}</h3>`;

        var cardBody = document.createElement('div');
        cardBody.classList.add('card__body');

        var timeEntrySection = buildTimeEntrySection();
        var consumerSection = await buildConsumerSection(consumersPresent);
        var saveDeleteCancel = buildSaveDeleteCancelButtons();

        // build card body
        cardBody.appendChild(timeEntrySection);
        cardBody.appendChild(consumerSection);
        cardBody.appendChild(saveDeleteCancel);
        // build card
        card.appendChild(cardHeader);
        card.appendChild(cardBody); //

        return card;
    }

    return {
        build: buildCard,
        populate: populateCard,
        getOverlapData,
        getSaveUpdateData,
        setAllowedConsumers,
        customRosterApplyFilterEvent,
        moveConsumersToTimeCard,
        handleActionNavEvent,
        clearAllGlobalVariables,
        enableSaveButtons,
        enableSaveButton,
    };
})();
